import React, { Fragment, useEffect, useState, useMemo } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ButtonWrapper from "../../../components/Button";
import InputWrapper from "../../../layout/inputWrapper";
import {
  additionalFar,
  ConstructionTypeOptions,
  developmentPlans,
  groupHousingOrMultiUnits,
  guaranteeList,
  natureOfCompounding,
  natureOfConstructionOption,
  natureOfConstructionOption2,
  natureOfConstructionOptions,
  proposalOptions,
  proposalOptionsPlotted,
  schemeNameList,
  schemeTypeList,
  specialProjectList,
  specialProjectOptions,
  TypeOfSchemeOptions,
  yesOrNo,
} from "../../../../TCPForms/data";
import { CloseButton, Col, Container, Row } from "react-bootstrap";
import { Toast } from "@egovernments/digit-ui-react-components";
import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Input,
  Modal,
  Table,
  TableContainer,
  TableHead,
} from "@mui/material";
import DxfFileUploader from "../../../reusableComponents/DxfFileUploader";
import { useHistory } from "react-router-dom";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";
import { Category, Close, Watch } from "@mui/icons-material";
import RemoveIcon from "@mui/icons-material/HighlightOff";
import AddIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import FileUploader from "../../../../TCPForms/reusableComponents/FileUploader";
import { useSelector } from "react-redux";
import useScrutinyProcess from "../../../../TCPForms/hooks/useScrutinyProcess";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import PlotDetailTable from "./helper/PlotDetailTable";

const SubStep1 = ({ formData, handleSubTabChange, userInfo, handleTabChange, setProposedSite, schemeTypeData, nonSchemeTypeData, id }) => {
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromSubStep1");
  Digit.SessionStorage.set("compensatoryFarDoc", formData[0]?.compensatoryFarDoc);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { documents } = useSelector((state) => state.formMT);
  const isProd = process.env.REACT_APP_COUNTER_ID === "1453752";
  console.log("isProd", isProd);

  console.log("documentFromRedux", documents);
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const [, scrutinyFlow, ScrutinySelector] = useScrutinyProcess();
  const isDA = applicationFlow === "DA" || formData?.department === "DA";

  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();
  const isRescrutiny = formData?.drawingDetail?.length > 0;
  const greenBuildingDocStoreId = documents?.find((doc) => doc.documentType === "greenBuildingDoc")?.fileStoreId;
  const compensatoryFarDocStoreId = documents?.find((doc) => doc.documentType === "compensatoryFarDoc")?.fileStoreId;
  const plotSizePrescribedDocStoreId = documents?.find((doc) => doc.documentType === "plotSizePrescribedDoc")?.fileStoreId;
  console.log("greenBuildingDocStoreId", greenBuildingDocStoreId, compensatoryFarDocStoreId, scrutinyFlow);

  const defaultValues = useMemo(
    () => ({
      ...formData,
      // plotDetails: [{ plotNo: "", typeOfPlot: "", proposedUnits: "" }] || [],
      planOn: formData?.planOn || "",
      descriptionOfLand: {
        ...formData?.descriptionOfLand,
        latitude: formData?.descriptionOfLand?.latitude || "",
        longitude: formData?.descriptionOfLand?.longitude,
      },
      numberOfHotels: formData?.numberOfHotels,
      fastPASId: formData?.fastPASId,
      proposalType: formData?.proposalType,
      isSpecialProject: formData?.isSpecialProject,
      groundCoverages: formData?.groundCoverages,
      fars: formData?.fars,
      buildingHeight: formData?.buildingHeight,
      previousSetbackFront: formData?.setbackFronts,
      previousSetbackRear: formData?.setbackRears,
      natureOfConstructionOptions: formData?.natureOfConstructionOptions,
      zone: formData?.zone,
      greenBuildingDoc: {
        fileStoreId: greenBuildingDocStoreId, // Pass greenBuildingDoc fileStoreId
      },
      compensatoryFarDoc: {
        fileStoreId: compensatoryFarDocStoreId, // Pass compensatoryFarDoc fileStoreId
      },
      watchPlotSizePrescribedDoc: {
        fileStoreId: plotSizePrescribedDocStoreId, // Pass plotSizePrescribedDoc fileStoreId
      },
      mapSubDetails: {
        ...formData?.mapSubDetails,
        plotDetails: formData?.mapSubDetails?.plotDetails || [{ seriesNo: "", plotNo: "" }],
      },
    }),
    [formData, greenBuildingDocStoreId, compensatoryFarDocStoreId, plotSizePrescribedDocStoreId]
  );

  const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({
    defaultValues,
    mode: "onBlur",
    shouldUnregister: false,
  });
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData?.filter((district) => !district.code?.includes("up"));
  const [fastPASData, setFastPasData] = useState(null);
  const [purchasableData, setPurchasableData] = useState(null);
  const [user, setUser] = useState(null);
  const [riskType, setRiskType] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const { data, isLoading: isDropDataLoading } = Digit.Hooks.obps.useMDMS(stateId, "MapSubmission", "DropdownsConfig");
  const { data: v2Data, isLoading: isV2DataLoading } = Digit.Hooks.obps.useMDMSV2(stateId, "BPA", ["ZoneWiseAuthorityName"]);
  console.log(data, "mdms data");
  const dropDownData = !isDropDataLoading && data?.MapSubmission?.DropdownsConfig?.[0];

  const watchDistrict = watch("district");

  const zoneList = useMemo(() => {
    let zones = [];
    if (v2Data?.BPA?.ZoneWiseAuthorityName) {
      const districtLower = (watchDistrict || "").toLowerCase().trim();

      v2Data.BPA.ZoneWiseAuthorityName.forEach((auth) => {
        const authorityLower = (auth.authorityName || "").toLowerCase();
        // Match authority if district name appears in authorityName (e.g. "kanpur" in "kanpur development authority")
        // When no district is selected yet, show all zones
        const isMatch = districtLower ? authorityLower.includes(districtLower) : true;

        if (isMatch) {
          auth.zones?.forEach((z) => {
            if (z.isActive) {
              zones.push({ name: z.name, label: z.name });
            }
          });
        }
      });

      // Deduplicate by name
      const uniqueZones = [];
      const map = new Map();
      for (const item of zones) {
        if (!map.has(item.name)) {
          map.set(item.name, true);
          uniqueZones.push(item);
        }
      }
      zones = uniqueZones;
    }
    return zones;
  }, [v2Data, watchDistrict]);

  const [schemeType, setSchemeType] = useState(false);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  // const [dataofTable, setDataOfTable] = useState([]); // Data to be displayed in the table
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state
  const Modal = useModal();
  // const { fields, append, remove } = useFieldArray({
  //   control,
  //   name: "plotDetails",
  // });

  const { fields: modalFields, append: addPlotNo, remove: removePlotNo } = useFieldArray({
    control,
    name: "mapSubDetails.plotDetails",
  });
  const currentPlotNo = getValues(`mapSubDetails.plotDetails[${modalFields?.length - 1}].plotNo`);

  console.log("ModLAASAFIelds", modalFields);

  const [
    watchProposalType,
    watchisSpecialProject,
    watchSpecialProject,
    watchPlotSubdivided,
    watchNeedComp,
    watchplotLeaseHold,
    watchisRevised,
    watchNoOfPLots,
    watchisApprovedLayout,
    watchisSetbackRequired,
    watchPlanOn,
    watchSpecialGroundCoverage,
    watchisSpecialFAR,
    watchProposal,
    watchnatureOfConstruction,
    watchbuildingClassification,
    watchlandUseType,
    watchSubZoneType,
    watchPrimaryUse,
    watchAtivityProposed,
    watchSectorNo,
    watchLandMark,
    watchKhasraNo,
    watchTehsil,
    watchSchemeType,
    watchProposalTypeFAR,
    watchGreenBuildingFAR,
    watchCompensatoryFAR,
    watchPlotArea,
    watchShelterFee,
    watchPurchasableFar,
    watchGroupHousingOrMultiUnits,
    watchedPlots,
    watchSchemeTypes,
    watchPlotSizePrescribed,
    watchPlotSizePrescribedDoc,
    watchCompunding,
    watchisAncestralProperty,
  ] = watch([
    "proposalType",
    "isSpecialProject",
    "specialProject",
    "plotSubdivided",
    "needCompounding",
    "plotLeaseHold",
    "isRevised",
    "noOfPlots",
    "isApprovedLayout",
    "isSetbackRequired",
    "planOn",
    "isSpecialGroundCoverage",
    "isSpecialFAR",
    "proposal",
    "natureOfConstruction",
    "buildingClassification",
    "zoneType",
    "subZoneType",
    "primaryUse",
    "activityProposed",
    "sectorNo",
    "landMark",
    "khasraNo",
    "tehsil",
    "descriptionOfLand.schemeType",
    "mapSubDetails.proposalTypeFAR",
    "greenBuildingFAR",
    "compensatoryFAR",
    "plotAreaDoc",
    "shelterFee",
    "purchasableFar",
    "groupHousingOrMultiUnits",
    "mapSubDetails.plotDetails",
    "schemeTypes",
    "plotSizePrescribed",
    "plotSizePrescribedDoc",
    "serviceType",
    "isAncestralProperty",
  ]);
  const mappedPlot = formData?.plotNumbers?.length;
  const totalPlots = parseInt(watchNoOfPLots, 10) || parseInt(mappedPlot, 10) || 0;
  const isCompounding = watchnatureOfConstruction === "Compounding";
  const isSelfCert =
    watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
    watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  // Calculate the number of full rows (each with 5 plots) and any remaining plots
  const fullRows = Math.floor(totalPlots / 3);
  const remainingPlots = totalPlots % 3;

  // Generate an array representing the plot inputs
  const plotInputs = Array.from({ length: totalPlots }, (_, index) => ({
    index: index + 1,
  }));

  // Get plotNumbers only when needed (in onSubmit) using getValues to avoid constant re-renders
  const getPlotNumbers = () => {
    return plotInputs.map((plot) => getValues(`plotNumbers[${plot.index}]`));
  };
  useEffect(() => {
    if (formData) {
      reset({
        ...formData,
        fastPASId: formData?.fastPASId,
        natureOfConstructionOptions: formData?.natureOfConstructionOptions,
        proposalType: formData?.proposalType,
        isSpecialProject: formData?.isSpecialProject,
        groundCoverages: formData?.groundCoverages,
        fars: formData?.fars,
        buildingHeight: formData?.buildingHeight,
        previousSetbackFront: formData?.setbackFronts,
        previousSetbackRear: formData?.setbackRears,
        compensatoryFarDoc: {
          fileStoreId: compensatoryFarDocStoreId,
        },
        greenBuildingDoc: {
          fileStoreId: greenBuildingDocStoreId,
        },
        mapSubDetails: {
          ...formData?.mapSubDetails,
          plotDetails: formData?.mapSubDetails?.plotDetails || [{ seriesNo: "", plotNo: "" }],
        },
      });
    }
  }, [formData]);

  useEffect(() => {
    if (watchPurchasableFar === "yes" && !purchasableData) {
      Modal("Apply Purchasable FAR", "Apply Purchasable FAR Before Proceeding", "warning");
    }
  }, [purchasableData, watchPurchasableFar]);

  useEffect(() => {
    if (
      watchnatureOfConstruction !== "Revalidation/Time Extension" &&
      watchnatureOfConstruction !== null &&
      fastPASData?.additionalDetails?.oldCaseApplicationNo
    ) {
      Modal(
        "Map submission is not allowed.",
        "The FastPass ID you entered belongs to an older case and cannot be used for a new map submission. Please use a FastPass ID generated for the current case.",
        "warning"
      );
    }
  }, [fastPASData, watchnatureOfConstruction]);

  useEffect(() => {
    if (watchSchemeType === "Non Scheme" && (watchProposal === "Plot sub-division" || watchProposal === "Amalgamation")) {
      Modal("Not allowed.", `${watchProposal} is not allowed in Non Scheme Cases.`, "warning");
    }
  }, [watchProposal, watchSchemeType]);

  const handleSearchClick = async (applicationNo) => {
    try {
      let response;
      let data;
      let mapSubData;
      let purchasableData;
      if (applicationNo) {
        response = await Digit.OBPSService.BPAFastPASSearch({ land_Id: applicationNo });
        if (response?.BPA?.length === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`,
          });
          return;
        } else if (response?.BPA?.[0]?.department !== applicationFlow) {
          setShowToast({
            key: "true",
            error: true,
            message: `Please use the selected department FASTPASID`,
          });
          return;
        }
        data = response?.BPA?.filter((item) => item.applicationType === "FORM_LANDUSE")?.[0];
        mapSubData = response?.BPA?.filter((item) => item.applicationType === "FORM_MAP")?.[0];
        purchasableData = response?.BPA?.filter((item) => item.applicationType === "FORM_PURCHASABLE_FAR")?.[0];
        if (data) {
          // if (data?.additionalDetails?.oldCaseApplicationNo) {
          //   Modal(
          //     "Map submission is not allowed.",
          //     "The FastPass ID you entered belongs to an older case and cannot be used for a new map submission. Please use a FastPass ID generated for the current case.",
          //     "warning"
          //   );
          // }
          const uuid = userInfo?.uuid;
          if (uuid) {
            const usersResponse = await Digit.UserService.userSearch(stateId, { uuid: [uuid] }, {});
            const userDetail = usersResponse?.user?.[0];
            Digit.SessionStorage.set("USER_DETAIL", userDetail);
            setUser(userDetail);
            if (data?.additionalDetails?.professionalInformation?.mobileNumber === userDetail?.mobileNumber) {
              setShowToast({
                key: "true",
                error: false,
                message: `Data fetched Successfully...!!`,
              });
            } else {
              setShowToast({
                key: "true",
                error: true,
                message: `Not Authorized to access this Id...!!`,
              });
              return;
            }
          }
        }
        Digit.SessionStorage.set("FASTPAS_ID", data);
        setFastPasData(data);
        setPurchasableData(purchasableData);
        setValue("descriptionOfLand", data?.descriptionOfLand);
        setValue("businessService", data?.department === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP");
        setValue("zoneType", data?.descriptionOfLand?.landUsesType);
        setValue("primaryUse", data?.descriptionOfLand?.activityAsPerMap);
        setValue("landMark", data?.descriptionOfLand?.landMark);
        setValue("sectorNo", data?.descriptionOfLand?.sectorNo);
        setValue("khasraNo", data?.descriptionOfLand?.khasraWithArea[0]?.khasraNo);
        setValue("schemeName", data?.descriptionOfLand?.schemeName);
        setValue("planOn", data?.descriptionOfLand?.planOn);
        setValue("riskType", data?.riskType);
        setValue("isGovernmentBuilding", data?.isGovernmentBuilding);
        setValue("approvalCertificateId", mapSubData?.approvalCertificateId);
        setValue("approvalCertificateUrl", mapSubData?.approvalCertificateUrl);
        setValue("selfDrawingPdfId", mapSubData?.selfDrawingPdfId);
        setValue("selfDrawingPdfUrl", mapSubData?.selfDrawingPdfUrl);
        setValue("selfDrawingPdfId", mapSubData?.selfDrawingPdfId);
        setValue("proposalId", mapSubData?.proposalId);
        setValue("proposalUrl", mapSubData?.proposalUrl);
        setValue("editPdfViaPdfId", mapSubData?.editPdfViaPdfId);
        setValue("editPdfViaPdfUrl", mapSubData?.editPdfViaPdfUrl);
        setValue("activityProposed", data?.descriptionOfLand?.activityProposed);
        setValue("plotArea", data?.descriptionOfLand?.landArea);
        setValue("mapSubDetails.sanctionValidityStartDate", mapSubData?.sanctionValidityStartDate || data?.layoutsanctionDate);
        setValue("mapSubDetails.sanctionValidityDate", mapSubData?.sanctionValidityDate || data?.validityDate);
        setValue("mapSubDetails.landUseApprovalLetter", data?.approvalLetterUrl);
        setValue("mapSubDetails.prevFileNo", mapSubData?.applicationNo || data?.additionalDetails?.oldCaseApplicationNo);
        setValue("mapSubDetails.landUseApprovalLetter", data?.approvalLetterUrl);
        setValue("plotArea", data?.descriptionOfLand?.landArea);
        setValue("plotAreaDoc", data?.descriptionOfLand?.plotAreaDoc);
        setValue("plotNo", data?.descriptionOfLand?.plotNo || data?.descriptionOfLand?.khasraDetails?.[0]?.plotNo);
        setValue("plotAreaPos", data?.descriptionOfLand?.plotAreaPossession);
        setValue("landAddress", data?.descriptionOfLand?.landAddress);
        setValue("tehsil", data?.landInfo?.owners?.[0]?.permanentAddress?.tehsil || data?.descriptionOfLand?.khasraDetails?.[0]?.tehsil || "");
        setValue("typeOfArea", data?.descriptionOfLand?.developmentArea);
        setValue("subZoneType", data?.descriptionOfLand?.subLandUseAsPerLayout);
        setValue("latitude", data?.descriptionOfLand?.latitude);
        setValue("longitude", data?.descriptionOfLand?.longitude);
        setValue("descriptionOfLand.approachRoadWidths[0].value", data?.descriptionOfLand?.approachRoadWidths?.[0]?.value);
        setValue("descriptionOfLand.roadWidths[0].value", data?.descriptionOfLand?.roadWidths[0]?.value);
        // setValue("schemeType", data?.descriptionOfLand?.schemeType);
        setValue("ConstructionType", data?.constructionType);
        setValue("khasraDetails", data?.khasraDetails);
        setValue("approvalLetterUrl", data?.approvalLetterUrl);
        setValue("totalBuildUpArea", mapSubData?.totalBuildUpArea);
        setValue("district", data?.landInfo?.owners?.[0]?.permanentAddress?.district || data?.descriptionOfLand?.khasraDetails?.[0]?.district || "");
        if (watchnatureOfConstruction === "Compounding") {
          setValue("applicationType", "FORM_COMPOUNDING");
          setValue("planOn", "FORM_MAP_COMPOUNDING");
        }
        const isApproved = data?.descriptionOfLand?.schemeType === "Scheme";
        const plotArea = data?.descriptionOfLand?.landArea;
        setRiskType(data?.riskType);
        setSchemeType(isApproved);
        // if (isApproved) {
        // }
        console.log("isApproved", isApproved);
        if (!isApproved) {
          console.log("insideIdIsApproved", isApproved);
          setValue("planOn", "Others");
          setValue("plotNo", data?.descriptionOfLand?.khasraDetails?.[0]?.plotNo || data?.descriptionOfLand?.plotNo);
          setValue("revenueVillage", data?.descriptionOfLand?.khasraDetails?.[0].village);
          setValue("tehsil", data?.descriptionOfLand?.khasraDetails?.[0].tehsil);
          setValue("district", data?.descriptionOfLand?.khasraDetails?.[0].district);
        }
        if (plotArea > 40000) {
          setValue("shelterFee", "no");
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  console.log("watchAtivityProposed", watchAtivityProposed);
  console.log("fastpasdata", fastPASData);
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    // First, find the relevant data once and store it
    const authorityData = masterData?.find((item) => item.name === authority);

    if (!authorityData) return { landUseList: [], landSubUseList: null }; // Return early if no authority data is found

    // Calculate landUseList, which doesn't depend on category
    const landUseList =
      authorityData?.LandUse?.map((item) => ({
        name: item.Type,
        value: item.Type,
      })) || []; // Fallback to an empty array if no LandUse is found

    let landSubUseList = null;

    // Only calculate landSubUseList if category is provided
    if (category) {
      const landUseCategory = authorityData?.LandUse?.find((item) => item.Type === category);

      // Only process if the specific category is found
      if (landUseCategory) {
        landSubUseList =
          landUseCategory.LandSubUse?.map((item) => ({
            name: item,
            label: item,
          })) || []; // Fallback to empty array if LandSubUse is not found
      }
    }

    console.log("loggingMasterData", landUseList, landSubUseList);

    return { landUseList, landSubUseList };
  };
  const restrictedLayoutActivities = [
    "Layout Plan (Commercial)",
    "Layout Plan (Affordable Housing)",
    "Layout Plan (Residential)",
    "Layout Plan (Community Facilities)",
  ].includes(watchAtivityProposed);
  console.log({ restrictedLayoutActivities }, "776767776");

  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    console.log("FromNonschemeDataCalled", masterData, category);

    const landUseList = masterData?.[0]?.CategeryType?.map((item) => {
      return { name: item.Categery, label: item.Categery };
    });
    const landSubUseList = masterData?.[0]?.CategeryType?.filter((item) => item.Categery === category)?.[0]?.["Activity Proposed"]?.map((item) => {
      return { name: item, label: item };
    });

    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return { landUseList, landSubUseList };
  };
  const { landUseList, landSubUseList } = !schemeType
    ? filterSchemeData(fastPASData?.selectedOffice, schemeTypeData, watchlandUseType, watchSubZoneType)
    : filterNonSchemeData(fastPASData?.selectedOffice, nonSchemeTypeData, watchlandUseType, watchSubZoneType);
  console.log(schemeType, "schemeTypeerrrrr");
  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };

  const onSubmit = (data) => {
    const fastPasdata = Digit.SessionStorage.get("FASTPAS_ID");
    console.log("datafromsubmit", data, fastPASData);
    if (watchnatureOfConstruction === "Compounding") {
      (data.applicationType = "FORM_COMPOUNDING"), (data.planOn = "FORM_MAP_COMPOUNDING");
    }
    // if (watchnatureOfConstruction === "Revalidation/Time Extension" && !getValues("mapSubDetails.sanctionValidityDate")) {
    //   Modal(
    //     "Not allowed",
    //     "Revalidation/Time Extension is not allowed for this application as the previous sanction validity date does not exist in the system.",
    //     "error"
    //   );
    //   return;
    // }
    if (watchPurchasableFar === "yes" && !purchasableData) {
      Modal("Apply Purchasable FAR", "Apply Purchasable FAR Before Proceeding", "warning");
      return;
    }

    if (
      watchnatureOfConstruction !== "Revalidation/Time Extension" &&
      watchnatureOfConstruction !== null &&
      fastPasdata?.additionalDetails?.oldCaseApplicationNo
    ) {
      Modal(
        "Map submission is not allowed.",
        "The FastPass ID you entered belongs to an older case and cannot be used for a new map submission. Please use a FastPass ID generated for the current case.",
        "warning"
      );
      return;
    }

    if (watchSchemeType === "Non Scheme" && (watchProposal === "Plot sub-division" || watchProposal === "Amalgamation")) {
      Modal("Not allowed.", `${watchProposal} is not allowed in Non Scheme Cases.`, "warning");
      return;
    }

    if (scrutinyFlow === "EDCR") {
      data.file = file;
      data.greenBuildingDoc = greenBuildingDocStoreId;
      data.compensatoryFarDoc = compensatoryFarDocStoreId;
      data.plotSizePrescribedDoc = plotSizePrescribedDocStoreId;
      data.applicantName = fastPASData?.landInfo?.owners?.[0]?.name || formData?.applicantName;
      data.department = fastPASData?.department || applicationFlow;
      data.landUseNo = fastPASData?.applicationNo;
      data.selectedOffice = fastPASData?.additionalDetails?.selectedOffice || "";
      data.licenseeName = fastPASData?.professionalInformation?.name;
      data.licenseeLicenceNumber = fastPASData?.professionalInformation?.licenseNumber;
      data.licenseeMobileNumber = fastPASData?.professionalInformation?.mobileNumber;
      data.licenseeEmailId = fastPASData?.professionalInformation?.emailId;
      data.licenseeAddress = user?.correspondenceAddress?.address;
      data.siteAddress = fastPASData?.descriptionOfLand?.landAddress;
      data.applicantEmailId = fastPASData?.landInfo?.owners?.[0]?.emailId || "";
      data.aplicantMobileNumber = fastPASData?.landInfo?.owners?.[0]?.mobileNumber || "";
      data.basicFAR = purchasableData?.basicFAR || 0;
      data.premiumFAR = purchasableData?.premiumFAR || 0;
      data.purchasableFAR = purchasableData?.purchasableFAR || 0;
      data.scrutinyFlow = "EDCR";
      data.landInfo = fastPasdata?.landInfo;
      data.approvalLetterId = fastPASData?.approvalLetterId;
      data.signatureId = fastPASData?.documents?.filter((doc) => doc.documentType === "signature")[0]?.fileStoreId || null;
    }
    if (isCompounding) {
      data.landInfo = fastPasdata?.landInfo;
      data.descriptionOfLand = fastPasdata?.descriptionOfLand;
      data.tenantId = stateId;
      data.land_Id = fastPasdata?.land_Id;
      data.documents = fastPasdata?.documents;
      data.nocDetails = fastPasdata?.nocDetails;
      data.occupancy = data?.zoneType;
      data.totalProposedArea = fastPASData?.descriptionOfLand?.landArea;
      data.department = fastPASData?.department || applicationFlow;
    }
    // if (watchnatureOfConstruction === "Revalidation/Time Extension") {
    //   if (!data.mapSubDetails.sanctionValidityDate) {
    //     Modal("Not allowed", "Previous Sanction validity date does not exist in ", "error");
    //   }
    // }
    if (!id && scrutinyFlow !== "EDCR") {
      (data.plotNumbers = getPlotNumbers()), (data.applicantName = fastPASData?.landInfo?.owners?.[0]?.name || "");
      data.applicantEmailId = fastPASData?.landInfo?.owners?.[0]?.emailId || "";
      data.aplicantMobileNumber = fastPASData?.landInfo?.owners?.[0]?.mobileNumber || "";
      data.selectedOffice = fastPASData?.additionalDetails?.selectedOffice || "";
      data.selectedCity = fastPASData?.additionalDetails?.selectedCity || "";
      data.landUseNo = fastPASData?.applicationNo;
      data.purchasableFAR = purchasableData?.descriptionOfLand?.properties?.[0]?.requiredAreaFAR || 0;
      data.fastPASId = fastPASData?.land_Id;
      data.signatureId = fastPASData?.documents?.filter((doc) => doc.documentType === "signature")[0]?.fileStoreId || null;
      (data.licenseeName = user?.name), (data.licenseeLicenceNumber = user?.registrationNumber);
      data.licenseeMobileNumber = user?.mobileNumber;
      data.licenseeEmailId = user?.emailId;
      data.licenseeAddress = user?.correspondenceAddress?.address;
      data.scrutinyFlow = "PDF";
      data.department = fastPASData?.department || applicationFlow;
      data.basicFAR = purchasableData?.basicFAR || 0;
      data.premiumFAR = purchasableData?.premiumFAR || 0;
      data.purchasableFAR = purchasableData?.purchasableFAR || 0;
      data.landInfo = fastPasdata?.landInfo;
      data.descriptionOfLand = fastPasdata?.descriptionOfLand;
      data.approvalLetterId = fastPASData?.approvalLetterId;
      data.documents = fastPasdata?.documents;
    }

    const uploadedDocs = documents || [];

    data.documents = [...(data.documents || []), ...uploadedDocs];
    if (id) {
      handleSubTabChange(1, formData);
    }

    isCompounding || scrutinyFlow !== "EDCR" || ["Revalidation/Time Extension", "Addition Extension", "Revision"]?.includes(watchnatureOfConstruction)
      ? handleTabChange(1, data)
      : handleSubTabChange(1, data);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  console.log("WatchNatueiu", watchnatureOfConstruction, formData);

  // useEffect(() => {
  //   if (watchnatureOfConstruction === "Revalidation/Time Extension" && !getValues("mapSubDetails.sanctionValidityDate")) {
  //     Modal(
  //       "Not allowed",
  //       "Revalidation/Time Extension is not allowed for this application as the previous sanction validity date does not exist in the system.",
  //       "error"
  //     );
  //   }
  // }, [watchnatureOfConstruction]);
  // useEffect(() => {
  //   if (!watchPlanOn) return;

  //   const isSelfCertPlan =
  //     watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
  //     watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";

  //   // const calculatedRiskType = isSelfCertPlan
  //   //   ? "Building Plan Low Risk, Self Certification Mode"
  //   //   : (watchlandUseType === "Residential" || watchSubZoneType === "Residential") &&
  //   //     watchAtivityProposed !== "Row Houses" &&
  //   //     watchAtivityProposed !== "Semi Detached" &&
  //   //     watchAtivityProposed !== "Detached"
  //   //   ? "High Risk and High Nivesh"
  //   //   : watchlandUseType === "Commercial"
  //   //   ? "High Risk and High Nivesh"
  //   //   : watchPlanOn !== "Others"
  //   //   ? "Building Plan-Low Risk"
  //   //   : "Others";

  //   // setRiskType(calculatedRiskType);

  //   const buildClass = calculatedRiskType === "Building Plan Low Risk, Self Certification Mode" ? "Building Plan-Low Risk" : calculatedRiskType;

  //   setValue("projectType", buildClass);

  //   if (isSelfCertPlan) {
  //     setValue("noOfPlots", 1);
  //     setValue("natureOfConstruction", "New");
  //   }
  // }, [watchPlanOn, watchlandUseType, watchSubZoneType, watchAtivityProposed, setValue]);
  const closeToast = () => {
    setShowToast(null);
  };
  if (watchSpecialProject === "Type design" && getValues("plotNo")) {
    setValue("plotNo", "");
  }

  if (applicationFlow === null) {
    return <DepartmentSelector />;
  }
  if (scrutinyFlow === null) {
    return <ScrutinySelector />;
  }

  // const totalUnits = watchedPlots.reduce((acc, curr) => {
  //   const units = parseInt(curr.proposedUnits, 10);
  //   return acc + (isNaN(units) ? 0 : units);
  // }, 0);
  const excludedActivitiesForResidential = [
    "Row Housing - Single units",
    "Semi-Detached - Single Units",
    "Detached - Single Units",
    "Row Housing - Multi units",
    "Semi-detached - Multi Units",
    "Detached - Multi Units",
    "Single Housing - EWS",
    "Single Housing - LIG",
  ];

  // const restrictedLandUses = [
  //   "Public & Semi-Public Facilities",
  //   "Traffic & Transportation",
  //   "Recreational",
  //   "Agricultural",
  //   "Highway Facility Zone",
  //   "Green Belt",
  // ];

  const excludeActivitiesForCommercial1 = [
    "Auction Market",
    "Cold storage",
    "Emergency Stock",
    "Fruit & Vegetable Market",
    "Junk Yard",
    "LPG / Gas Godown",
    "Storage/Warehousing",
    "Store/Godown",
    "Wholesale centres for Agriculture produce",
    "Wholesale Market/Trade/Wholesale business",
  ];

  const excludeActivitiesForCommercial3 = ["Emergency Stock", "Junk Yard", "LPG / Gas Godown"];

  const excludeActivitiesForCommercialOfficeUse = [
    "Auction Market",
    "Emergency Stock",
    "Fruit & Vegetable Market",
    "Junk Yard",
    "LPG / Gas Godown",
    "Wholesale centres for Agriculture produce",
    "Wholesale Market/Trade/Wholesale business",
  ];

  const excludeActivitiesForCommercialAgri = [
    "Canteen",
    "Coal & Wood Stock",
    "Commercial Complex",
    "Convenient Shopping",
    "Fruit & Vegetable Market",
    "Hotel (<20 rooms)",
    "Miniplex",
    "Motel",
    "Motor Vehicle Showroom (Automobile sales/Purchase, Workshop, Accessories Centre)",
    "Open-air/ Rooftop Restaurants",
    "PCO/Cellular Mobile Service",
    "Plotted Development",
    "Resort",
    "Restaurant",
    "Retail Shops",
    "Service Apartment",
    "Shopping Centre",
    "Shops for sale of Motor vehicle spare parts",
    "Showroom (other than motor vehicle)",
    "Resi-Com. Building",
  ];

  const excludeMixedUseActivities = ["Emergency Stock", "Junk Yard", "LPG / Gas Godown"];

  const excludePublicAmenitiesBuilt = [
    "Auditorium",
    "Banquet Hall",
    "Community Guidance Centre",
    "Community Hall",
    "Community Service Centre",
    "Community Welfare Centre",
    "Compost Plant",
    "Convention Centre",
    "Information Centre",
    "Marriage Hall",
    "Meeting Hall",
    "Multipurpose Hall",
    "Museum",
    "Open Air Theatre",
    "Prison",
    "Theatre",
    "Utilities & Services",
    "Plotted Development",
  ];

  const excludePublicAmenitiesGrameen = ["Auditorium", "Compost Plant", "Convention Centre", "Museum", "Open Air Theatre", "Prison", "Theatre"];

  const excludePublicActivitiesCommercial = [
    "Auditorium",
    "Banquet Hall",
    "Community Guidance Centre",
    "Community Hall",
    "Community Service Centre",
    "Community Welfare Centre",
    "Compost Plant",
    "Convention Centre",
    "Creche and Day care Centre",
    "Dharamshala",
    "Information Centre",
    "Marriage Hall",
    "Meeting Hall",
    "Microwave and wireless centre",
    "Museum",
    "Open Air Theatre",
    "Prison",
    "Reading Room",
    "Theatre",
  ];

  const excludePublicActivitiesLargeIndustries = [
    "Auditorium",
    "Banquet Hall",
    "Community Guidance Centre",
    "Community Hall",
    "Community Service Centre",
    "Community Welfare Centre",
    "Convention Centre",
    "Creche and Day care Centre",
    "Dharamshala",
    "Information Centre",
    "Marriage Hall",
    "Meeting Hall",
    "Microwave and wireless centre",
    "Museum",
    "Open Air Theatre",
    "Prison",
    "Reading Room",
    "Theatre",
  ];

  const excludePublicOfficeTraffic = [
    "Auditorium",
    "Banquet Hall",
    "Community Guidance Centre",
    "Community Hall",
    "Community Service Centre",
    "Community Welfare Centre",
    "Compost Plant",
    "Convention Centre",
    "Information Centre",
    "Marriage Hall",
    "Meeting Hall",
    "Multipurpose Hall",
    "Museum",
    "Open Air Theatre",
    "Prison",
    "Theatre",
  ];

  const excludeAgricultural = [
    "Buildings/establishment related to public utilities and services",
    "Compost Plant",
    "Creche and Day care Centre",
    "Electric Sub-station",
    "Fire station",
    "Garbage Collection Centre",
    "Microwave and wireless centre",
    "Prison",
    "Public/Community Toilet",
    "Reading Room",
    "Sewerage treatment Plant",
    "Utilities & Services",
    "Water Works",
    "Plotted Development",
  ];

  const sprinklerRequiredPrimaryUses = ["Community Facilities (Healthcare Buildings)", "Community Facilities (Educational Buildings)"];

  const includeIsBuildingFullySprinkledActivities = [
    "Group Housing",
    "Group Housing - Affordable",
    "Group Housing - EWS",
    "Group Housing - LIG",
    "Hotel (<20 rooms)",
    "Hotel (>20 rooms)",
    "All Buildings",
    "All Buildings",
    "Community Hall",
    "Auditorium",
    "Art Gallery/Exhibition Centre",
    "Museum",
    "Theatre",
    "Health club / Gymnasium",
    "Theatre",
    "Health club / Gymnasium",
    "Religious  Buildings",
    "Music / Dance and Drama Arts Training Centre",
    "Health club / Gymnasium",
    "Amusement Park",
    "Single Screen Cinema",
    "Miniplex",
    "Multiplex",
    "Club",
    "All Buildings",
    "Warehouse",
    "Cold Storage",
    "Store / Godown",
    "All Buildings",
    "Hazardous / Polluting Industry",
    "Hazardous Industries",
  ];

  // ...existing code...
  // Assuming nonSchemeTypeData structure is like: [{ CategoryType: [{ Category: "Residential", ... }, ...] }]
  const categoryArray =
    Array.isArray(nonSchemeTypeData) && nonSchemeTypeData[0]?.CategoryType ? nonSchemeTypeData[0].CategoryType.map((item) => item.Category) : [];
  console.log("Categories:", categoryArray);
  const formattedCategoryArray = categoryArray.map((cat) => ({ name: cat, label: cat }));
  const getFilteredActivityOptions = () => {
    const activityProposeData = nonSchemeTypeData?.[0]?.CategoryType;
    if (!Array.isArray(activityProposeData)) return [];
    const residential = activityProposeData.find((item) => item.Category === "Residential");
    const commercial = activityProposeData.find((item) => item.Category === "Commercial");
    const industrial = activityProposeData.find((item) => item.Category === "Industrial");
    const officeUse = activityProposeData.find((item) => item.Category === "Office");
    const agriculture = activityProposeData.find((item) => item.Category === "Agriculture");
    const trafficTransport = activityProposeData.find((item) => item.Category === "Traffic & Transport");
    const recreational = activityProposeData.find((item) => item.Category === "Parks, Play-ground / Open-spaces, Recreational");
    const communityHealth = activityProposeData.find((item) => item.Category === "Community Facilities (Healthcare Buildings)");
    const communityEducation = activityProposeData.find((item) => item.Category === "Community Facilities (Educational Buildings)");
    const publicAmenities = activityProposeData.find((item) => item.Category === "Community Facilities (Public Amenities/Utilities Buildings)");
    const proposed = commercial?.["Activity Proposed"] || [];
    const resProposed = residential?.["Activity Proposed"] || [];
    const indProposed = industrial?.["Activity Proposed"] || [];
    const officeProposed = officeUse?.["Activity Proposed"] || [];
    const trafficProposed = trafficTransport?.["Activity Proposed"] || [];
    const recreationProposed = recreational?.["Activity Proposed"] || [];
    const agricultureProposed = agriculture?.["Activity Proposed"] || [];
    const communityHealthProposed = communityHealth?.["Activity Proposed"] || [];
    const communityEducationProposed = communityEducation?.["Activity Proposed"] || [];
    const publicAmenitiesProposed = publicAmenities?.["Activity Proposed"] || [];
    const landUse = watchlandUseType;
    const subZone = watchSubZoneType;
    const primaryUse = watchPrimaryUse;

    const simpleReturn = (list) => list.map((item) => ({ name: item, label: item }));

    // if (restrictedLandUses.includes(landUse) || restrictedLandUses.includes(subZone)) {
    //   return simpleReturn(["Plotted Development"]);
    // }

    console.log("commercial", trafficProposed);
    const conditions = [
      {
        match:
          landUse === "Commercial" &&
          ["Commercial 1- Retail/CBD/Sub CBD", "Commercial 2- Wholesale/ Godown"].includes(subZone) &&
          primaryUse === "Residential",
        excludeFrom: resProposed,
        excludeList: excludedActivitiesForResidential,
      },
      {
        match: primaryUse === "Commercial" && landUse === "Residential" && subZone === "Built-up",
        excludeFrom: proposed,
        excludeList: excludeActivitiesForCommercial1,
      },
      {
        match: primaryUse === "Commercial" && landUse === "Residential" && subZone === "Residential",
        excludeFrom: proposed,
        excludeList: excludeActivitiesForCommercialOfficeUse,
      },
      {
        match: primaryUse === "Commercial" && landUse === "Residential" && subZone === "Grameen Abaadi",
        excludeFrom: proposed,
        excludeList: excludeActivitiesForCommercial3,
      },
      {
        match:
          (primaryUse === "Commercial" && landUse === "Commercial" && subZone === "Commercial 1- Retail/CBD/Sub CBD") ||
          subZone === "Commercial 1- Bazaar Street",
        excludeFrom: proposed,
        excludeList: excludeActivitiesForCommercialOfficeUse,
      },
      {
        match: primaryUse === "Commercial" && landUse === "Commercial" && subZone === "Mixed Use 1 & 2",
        excludeFrom: proposed,
        excludeList: excludeMixedUseActivities,
      },
      {
        match: primaryUse === "Commercial" && landUse === "Commercial" && subZone === "Commercial 2- Wholesale/ Godown",
        excludeFrom: proposed,
        excludeList: ["Resi-Com. Building"],
      },

      {
        match: primaryUse === "Commercial" && landUse === "Industrial" && subZone === "Large Industries",
        excludeFrom: proposed,
        excludeList: ["Miniplex", "Multiplex", "Shopping Mall", "Shopping Centre", "Single Screen Cinema"],
      },
      {
        match: primaryUse === "Commercial" && landUse === "Office Use" && subZone === "Office Buildings",
        excludeFrom: proposed,
        excludeList: excludeActivitiesForCommercialOfficeUse,
      },
      {
        match: primaryUse === "Commercial" && landUse === "Public & Semi-Public Facilities" && subZone === "Public & Semi-Public",
        excludeFrom: proposed,
        excludeList: ["Emergency Stock", "Junk Yard", "LPG / Gas Godown"],
      },
      {
        match: primaryUse === "Commercial" && landUse === "Traffic & Transportation" && subZone === "Transport 1 & 2,Parking",
        excludeFrom: proposed,
        excludeList: ["Resi-Com. Building", "Shopping Mall", "Multiplex"],
      },
      {
        match: primaryUse === "Commercial" && landUse === "Recreational" && subZone === "Recreational-1 & 2",
        includeOnly: [
          "Canteen",
          "Multiplex",
          "Open-air/ Rooftop Restaurants",
          "PCO/Cellular Mobile Service",
          "Restaurant",
          "Retail Shops",
          "Shopping Mall",
          "Showroom (other than motor vehicle)",
        ],
      },
      {
        match: primaryUse === "Commercial" && landUse === "Agricultural" && subZone === "Agricultural",
        excludeFrom: proposed,
        excludeList: excludeActivitiesForCommercialAgri,
      },
      {
        match: primaryUse === "Commercial" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
        excludeFrom: proposed,
        excludeList: ["Resi-Com. Building"],
      },
      {
        match: primaryUse === "Commercial" && landUse === "Green Belt" && subZone === "Green Belt",
        includeOnly: [
          "LPG / Gas Godown",
          "Petrol Pump/ Filling Station (CNG/PNG/EV)",
          "Petrol Pump/ Filling Station cum Service Station (CNG/PNG/EV)",
          "Shopping Mall",
          "Way-side Amenities/Dhaba",
        ],
      },
      {
        match: primaryUse === "Industrial" && landUse === "Residential" && (subZone === "Built-up" || subZone === "Residential"),
        includeOnly: [
          "Bio Diesel Plant",
          "Cottage Industries",
          "Dangerous Industries",
          "Data Processing Centre",
          "Flour Mill",
          "Hazardous / Polluting Industry",
          "Milk Collection centre",
          "Plotted Development",
          "Service Industries",
          "Software / Information Technology Park",
        ],
      },
      {
        match:
          primaryUse === "Industrial" &&
          (landUse === "Residential" || landUse === "Commercial") &&
          (subZone === "Grameen Abaadi" ||
            subZone === "Mixed Use 1 & 2" ||
            subZone === "Commercial 1- Retail/CBD/Sub CBD" ||
            subZone === "Commercial 1- Bazaar Street"),
        includeOnly: [
          "Bio Diesel Plant",
          "Cottage Industries",
          "Dangerous Industries",
          "Data Processing Centre",
          "Flour Mill",
          "Industries (Other than MSME)",
          "Logistic Park",
          "Milk Collection centre",
          "Plotted Development",
          "Service Industries",
          "Software / Information Technology Park",
          "Warehouse",
        ],
      },
      {
        match: primaryUse === "Industrial" && landUse === "Commercial" && subZone === "Commercial 2- Wholesale/ Godown",
        includeOnly: [
          "Bio Diesel Plant",
          "Cottage Industries",
          "Flour Mill",
          "Industries (Other than MSME)",
          "Logistic Park",
          "Milk Collection centre",
          "Plotted Development",
          "Service Industries",
          "Software / Information Technology Park",
          "Warehouse",
        ],
      },
      {
        match: primaryUse === "Industrial" && landUse === "Industrial" && subZone === "Small Industries",
        includeOnly: [
          "Bio Diesel Plant",
          "Cottage Industries",
          "Data Processing Centre",
          "Flour Mill",
          "Industries (Other than MSME)",
          "Logistic Park",
          "Milk Collection centre",
          "Plotted Development",
          "Service Industries",
          "Software / Information Technology Park",
          "Warehouse",
        ],
      },
      {
        match: primaryUse === "Industrial" && landUse === "Industrial" && subZone === "Large Industries",
        excludeFrom: indProposed,
        excludeOnly: ["Dangerous Industries", "Gas Godown", "Cold Storage"],
      },
      {
        match:
          primaryUse === "Industrial" &&
          (landUse === "Office Use" || landUse === "Public & Semi-Public Facilities") &&
          (subZone === "Office Buildings" || subZone === "Public & Semi-Public"),
        excludeFrom: indProposed,
        excludeList: ["Data Processing Centre", "Logistic Park", "Service Industries", "Software / Information Technology Park", "Warehouse"],
      },
      {
        match: primaryUse === "Industrial" && landUse === "Traffic & Transportation" && subZone === "Transport 1 & 2,Parking",
        excludeFrom: indProposed,
        excludeList: ["Data Processing Centre", "Warehouse"],
      },
      {
        match: primaryUse === "Industrial" && landUse === "Recreational" && subZone === "Recreational-1 & 2",
        includeFrom: indProposed,
        includeOnly: ["Plotted Development"],
      },
      {
        match: primaryUse === "Industrial" && landUse === "Agricultural" && subZone === "Agricultural",
        excludeFrom: indProposed,
        excludeList: ["Dangerous Industries", "Data Processing Centre", "Service Industries", "Software / Information Technology Park"],
      },
      {
        match: primaryUse === "Industrial" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
        includeFrom: indProposed,
        includeOnly: [
          "Bio Diesel Plant",
          "Cottage Industries",
          "Dangerous Industries",
          "Flour Mill",
          "Industries (Other than MSME)",
          "Logistic Park",
          "Pasteurizing Plant",
          "Plotted Development",
          "Warehouse",
        ],
      },
      {
        match: primaryUse === "Industrial" && landUse === "Green Belt" && subZone === "Green Belt",
        includeFrom: indProposed,
        includeOnly: ["Plotted Development"],
      },
      {
        match: primaryUse === "Office Use" && landUse === "Commercial" && subZone === "Commercial 2- Wholesale/ Godown",
        includeFrom: officeProposed,
        includeOnly: ["Plotted Development"],
      },
      {
        match: primaryUse === "Office Use" && landUse === "Industrial" && subZone === "Large Industries",
        excludeFrom: officeProposed,
        excludeList: ["Bank", "BPO", "Call Centre", "Cyber ​​cafe", "Private office, Agent Office etc."],
      },
      {
        match:
          primaryUse === "Office Use" &&
          (landUse === "Traffic & Transportationl" || landUse === "Highway Facility Zone") &&
          (subZone === "Transport 1 & 2,Parking" || subZone === "Highway Facilities"),
        includeFrom: officeProposed,
        includeOnly: ["Bank", "BPO", "Call Centre", "Cyber ​​cafe", "Private office, Agent Office etc."],
      },
      {
        match:
          primaryUse === "Office Use" &&
          (landUse === "Recreational" || landUse === "Agricultural" || landUse === "Green Belt") &&
          (subZone === "Recreational-1 & 2" || subZone === "Agricultural" || subZone === "Green Belt"),
        includeFrom: officeProposed,
        includeOnly: ["Plotted Development"],
      },
      {
        match:
          primaryUse === "Agriculture" &&
          (landUse === "Residential" || landUse === "Industrial" || landUse === "Green Belt") &&
          (subZone === "Built-up" || subZone === "Residential" || subZone === "Large Industries" || subZone === "Green Belt"),
        includeFrom: agricultureProposed,
        includeOnly: [],
      },
      {
        match:
          primaryUse === "Agriculture" &&
          (landUse === "Commercial" ||
            landUse === "Industrial" ||
            landUse === "Office Use" ||
            landUse === "Public & Semi-Public Facilities" ||
            landUse === "Traffic & Transportation" ||
            landUse === "Recreational" ||
            landUse === "Highway Facility Zone") &&
          (subZone === "Mixed Use 1 & 2" ||
            subZone === "Commercial 1- Bazaar Street" ||
            subZone === "Commercial 1- Retail/CBD/Sub CBD" ||
            subZone === "Commercial 2- Wholesale/ Godown" ||
            subZone === "Small Industries" ||
            subZone === "Office Buildings" ||
            subZone === "Public & Semi-Public" ||
            subZone === "Transport 1 & 2,Parking" ||
            subZone === "Recreational-1 & 2" ||
            subZone === "Highway Facilities"),
        includeFrom: agricultureProposed,
        includeOnly: ["Cattle Colony", "Dairy Farm", "Poultry Farm"],
      },
      {
        match: primaryUse === "Agriculture" && landUse === "Residential" && subZone === "Grameen Abaadi",
        includeFrom: agricultureProposed,
        includeOnly: ["Cattle Colony", "Dairy Farm", "Dhobi Ghat", "Poultry Farm"],
      },
      {
        match: primaryUse === "Agriculture" && landUse === "Agricultural" && subZone === "Agricultural",
        excludeFrom: agricultureProposed,
        excludeOnly: [],
      },
      {
        match:
          primaryUse === "Traffic & Transport" &&
          (landUse === "Residential" || landUse === "Recreational") &&
          (subZone === "Built-up" || subZone === "Residential" || subZone === "Recreational-1 & 2"),
        includeFrom: trafficProposed,
        includeOnly: ["Bus Stop", "Parking Lot", "Taxi/Tempo Stand"],
      },
      {
        match:
          primaryUse === "Traffic & Transport" &&
          (landUse === "Residential" || landUse === "Commercial") &&
          (subZone === "Grameen Abaadi" || subZone === "Commercial 1- Retail/CBD/Sub CBD" || subZone === "Commercial 1- Bazaar Street"),
        includeFrom: trafficProposed,
        includeOnly: ["Bus Depot", "Bus Terminal", "Transport Nagar", "Weighbridge/ Dharmakanta", "Flying Club"],
      },
      {
        match: primaryUse === "Traffic & Transport" && landUse === "Agricultural" && subZone === "Agricultural",
        includeFrom: trafficProposed,
        includeOnly: ["Bus Depot", "Bus Terminal", "Transport Nagar", "Weighbridge/ Dharmakanta"],
      },
      {
        match:
          primaryUse === "Traffic & Transport" &&
          (landUse === "Industrial" ||
            landUse === "Commercial" ||
            landUse === "Office Use" ||
            landUse === "Public & Semi-Public Facilities" ||
            landUse === "Traffic & Transportation") &&
          (subZone === "Mixed Use 1 & 2" ||
            subZone === "Commercial 2- Wholesale/ Godown" ||
            subZone === "Small Industries" ||
            subZone === "Large Industries" ||
            subZone === "Office Buildings" ||
            subZone === "Public & Semi-Public" ||
            subZone === "Transport 1 & 2,Parking"),
        excludeFrom: trafficProposed,
        excludeOnly: [],
      },
      {
        match: primaryUse === "Traffic & Transport" && landUse === "Green Belt" && subZone === "Green Belt",
        includeFrom: trafficProposed,
        includeOnly: [],
      },
      {
        match: primaryUse === "Recreational" && landUse === "Residential" && subZone === "Built-up",
        includeFrom: recreationProposed,
        includeOnly: ["Club", "Park", "Playground/Sports Ground", "Swimming Pool"],
      },
      {
        match: primaryUse === "Recreational" && landUse === "Residential" && subZone === "Grameen Abaadi",
        includeFrom: recreationProposed,
        includeOnly: ["Park", "Playground/Sports Ground", "Swimming Pool"],
      },
      {
        match: primaryUse === "Recreational" && landUse === "Residential" && subZone === "Residential",
        excludeFrom: recreationProposed,
        excludeOnly: ["Shooting Range", "Helipad"],
      },
      {
        match:
          primaryUse === "Recreational" &&
          (landUse === "Commercial" || landUse === "Industrial") &&
          (subZone === "Mixed Use 1 & 2" || subZone === "Small Industries"),
        excludeFrom: recreationProposed,
        excludeOnly: ["Shooting Range"],
      },
      {
        match:
          primaryUse === "Recreational" &&
          (landUse === "Commercial" ||
            landUse === "Office Use" ||
            landUse === "Public & Semi-Public Facilities" ||
            landUse === "Traffic & Transportation") &&
          (subZone === "Commercial 1- Retail/CBD/Sub CBD" ||
            subZone === "Commercial 1- Bazaar Street" ||
            subZone === "Office Buildings" ||
            subZone === "Public & Semi-Public" ||
            subZone === "Transport 1 & 2,Parking"),
        excludeFrom: recreationProposed,
        excludeList: ["Club", "Park", "Playground/Sports Ground", "Swimming Pool", "Helipad"],
      },
      {
        match:
          primaryUse === "Recreational" &&
          (landUse === "Commercial" || landUse === "Industrial" || landUse === "Highway Facility Zone" || landUse === "Green Belt") &&
          (subZone === "Commercial 2- Wholesale/ Godown" || subZone === "Highway Facilities" || subZone === "Green Belt"),
        excludeFrom: recreationProposed,
        excludeList: ["Club", "Shooting Range"],
      },
      {
        match: primaryUse === "Community Facilities (Healthcare Buildings)" && landUse === "Residential" && subZone === "Built-up",
        excludeFrom: communityHealthProposed,
        excludeList: ["Dental College", "Medical College"],
      },
      {
        match:
          primaryUse === "Community Facilities (Healthcare Buildings)" &&
          (landUse === "Commercial" ||
            landUse === "Industrial" ||
            landUse === "Recreational" ||
            landUse === "Agricultural" ||
            landUse === "Green Belt") &&
          (subZone === "Commercial 2- Wholesale/ Godown" ||
            subZone === "Large Industries" ||
            subZone === "Recreational-1 & 2" ||
            subZone === "Agricultural" ||
            subZone === "Green Belt"),
        includeFrom: communityHealthProposed,
        includeOnly: [],
      },
      {
        match: primaryUse === "Community Facilities (Healthcare Buildings)" && landUse === "Industrial" && subZone === "Small Industries",
        excludeFrom: communityHealthProposed,
        excludeList: ["Hospitals (> 50 beds)", "Dental College", "Medical College", "Nursing Institutes"],
      },
      {
        match:
          primaryUse === "Community Facilities (Healthcare Buildings)" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
        excludeFrom: communityHealthProposed,
        excludeList: ["Maternity Hospitals", "Nursing Homes", "Orphanage", "Small Hospitals (Up to 50 beds)", "Reformatory"],
      },
      {
        match:
          primaryUse === "Community Facilities (Educational Buildings)" &&
          landUse === "Residential" &&
          (subZone === "Built-up" || subZone === "Residential"),
        excludeFrom: communityEducationProposed,
        excludeOnly: ["Universities"],
      },
      {
        match:
          primaryUse === "Community Facilities (Educational Buildings)" &&
          (landUse === "Residential" || landUse === "Industrial") &&
          (subZone === "Grameen Abaadi" || subZone === "Small Industries"),
        excludeFrom: communityEducationProposed,
        excludeList: [
          "Cottage / Industry Training",
          "Degree College",
          "General Education Institute",
          "Higher Technical Institute",
          "Management Institute",
          "Polytechnic",
          "Technical Institute",
          "Universities",
        ],
      },
      {
        match:
          primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Commercial" && subZone === "Commercial 1- Retail/CBD/Sub CBD",
        excludeFrom: communityEducationProposed,
        excludeList: [
          "Cottage / Industry Training",
          "General Education Institute",
          "Higher Technical Institute",
          "Management Institute",
          "Polytechnic",
          "Technical Institute",
          "Universities",
        ],
      },
      {
        match: primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Commercial" && subZone === "Commercial 1- Bazaar Street",
        excludeFrom: communityEducationProposed,
        excludeList: [
          "Cottage / Industry Training",
          "General Education Institute",
          "Higher Technical Institute",
          "Management Institute",
          "Nursery School",
          "Polytechnic",
          "Library",
          "Primary school",
          "Technical Institute",
          "Universities",
        ],
      },
      {
        match:
          primaryUse === "Community Facilities (Educational Buildings)" &&
          (landUse === "Commercial" || landUse === "Industrial" || landUse === "Recreational" || landUse === "Green Belt") &&
          (subZone === "Commercial 2- Wholesale/ Godown" ||
            subZone === "Large Industries" ||
            subZone === "Recreational-1 & 2" ||
            subZone === "Green Belt"),
        includeFrom: communityEducationProposed,
        includeOnly: [],
      },
      {
        match:
          primaryUse === "Community Facilities (Educational Buildings)" &&
          (landUse === "Office Use" || landUse === "Traffic & Transportation") &&
          (subZone === "Office Buildings" || subZone === "Transport 1 & 2,Parking"),
        includeFrom: communityEducationProposed,
        includeOnly: ["Nursery School", "Library", "Primary school", "Reading Room"],
      },
      {
        match: primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Agricultural" && subZone === "Agricultural",
        excludeFrom: communityEducationProposed,
        excludeList: [
          "Cottage / Industry Training",
          "Degree College",
          "General Education Institute",
          "Higher Technical Institute",
          "Management Institute",
          "Polytechnic",
          "Technical Institute",
          "Universities",
        ],
      },
      {
        match:
          primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
        includeFrom: communityEducationProposed,
        includeOnly: [
          "Coaching Institutes/Centres",
          "Inter College",
          "Law College",
          "Secondary/High School",
          "Music / Dance and Drama Arts Training Centre",
          "Art Gallery/Exhibition centre",
          "Religious  Centre",
        ],
      },
      {
        match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Residential" && subZone === "Built-up",
        excludeFrom: publicAmenitiesProposed,
        excludeList: excludePublicAmenitiesBuilt,
      },
      {
        match:
          (primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Residential") ||
          landUse === "Commercial" ||
          (landUse === "Industrial" && subZone === "Residential") ||
          subZone === "Mixed Use 1 & 2" ||
          subZone === "Commercial 1- Retail/CBD/Sub CBD" ||
          subZone === "Commercial 1- Bazaar Street" ||
          subZone === "Small Industries",
        excludeFrom: publicAmenitiesProposed,
        excludeList: ["Compost Plant", "Prison"],
      },
      {
        match:
          primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Residential" && subZone === "Grameen Abaadi",
        excludeFrom: publicAmenitiesProposed,
        excludeList: excludePublicAmenitiesGrameen,
      },
      {
        match:
          primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" &&
          landUse === "Commercial" &&
          subZone === "Commercial 2- Wholesale/ Godown",
        excludeFrom: publicAmenitiesProposed,
        excludeList: excludePublicActivitiesCommercial,
      },
      {
        match:
          primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Industrial" && subZone === "Large Industries",
        excludeFrom: publicAmenitiesProposed,
        excludeList: excludePublicActivitiesLargeIndustries,
      },
      {
        match:
          primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" &&
          (landUse === "Office Use" || landUse === "Traffic & Transportation") &&
          (subZone === "Office Buildings" || subZone === "Transport 1 & 2,Parking"),
        excludeFrom: publicAmenitiesProposed,
        excludeList: excludePublicOfficeTraffic,
      },
      {
        match:
          primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Agricultural" && subZone === "Agricultural",
        excludeFrom: publicAmenitiesProposed,
        excludeList: excludeAgricultural,
      },
      {
        match:
          primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" &&
          landUse === "Highway Facility Zone" &&
          subZone === "Highway Facilities",
        excludeFrom: publicAmenitiesProposed,
        excludeList: ["Compost Plant", "Creche and Day care Centre", "Prison", "Reading Room"],
      },
      {
        match:
          primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" &&
          (landUse === "Recreational" || landUse === "Green Belt") &&
          (subZone === "Recreational-1 & 2" || subZone === "Green Belt"),
        excludeFrom: publicAmenitiesProposed,
        excludeList: ["Compost Plant", "Creche and Day care Centre", "Prison", "Reading Room"],
      },
      {
        match:
          primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" &&
          landUse === "Public & Semi-Public Facilities" &&
          subZone === "Public & Semi-Public",
        excludeFrom: publicAmenitiesProposed,
        excludeList: [],
      },
      {
        match:
          primaryUse === "Community Facilities (Healthcare Buildings)" &&
          landUse === "Public & Semi-Public Facilities" &&
          subZone === "Public & Semi-Public",
        excludeFrom: communityHealthProposed,
        excludeList: [],
      },
    ];

    for (const cond of conditions) {
      if (cond.match) {
        let list = [];

        if (primaryUse === "Commercial") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = proposed.filter((a) => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = proposed.filter((a) => !cond.excludeOnly.includes(a));
            } else {
              list = cond.excludeFrom?.filter((a) => !cond.excludeList.includes(a)) || [];
            }
          }
        } else if (primaryUse === "Industrial") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = indProposed.filter((a) => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = indProposed.filter((a) => !cond.excludeOnly.includes(a));
            } else {
              list = cond.excludeFrom?.filter((a) => !cond.excludeList.includes(a)) || [];
            }
          }
        } else if (primaryUse === "Residential") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = resProposed.filter((a) => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = resProposed.filter((a) => !cond.excludeOnly.includes(a));
            } else {
              list = cond.excludeFrom?.filter((a) => !cond.excludeList.includes(a)) || [];
            }
          }
        } else if (primaryUse === "Office Use") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = officeProposed.filter((a) => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = officeProposed.filter((a) => !cond.excludeOnly.includes(a));
            } else {
              list = cond.excludeFrom?.filter((a) => !cond.excludeList.includes(a)) || [];
            }
          }
        } else if (primaryUse === "Traffic & Transport") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = trafficProposed.filter((a) => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = trafficProposed.filter((a) => !cond.excludeOnly.includes(a));
            } else {
              list = cond.excludeFrom?.filter((a) => !cond.excludeList.includes(a)) || [];
            }
          }
        } else if (primaryUse === "Recreational") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = recreationProposed.filter((a) => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = recreationProposed.filter((a) => !cond.excludeOnly.includes(a));
            } else {
              list = cond.excludeFrom?.filter((a) => !cond.excludeList.includes(a)) || [];
            }
          }
        } else if (primaryUse === "Agriculture") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = agricultureProposed.filter((a) => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = agricultureProposed.filter((a) => !cond.excludeOnly.includes(a));
            } else {
              list = cond.excludeFrom?.filter((a) => !cond.excludeList.includes(a)) || [];
            }
          }
        } else if (primaryUse === "Community Facilities (Healthcare Buildings)") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = communityHealthProposed.filter((a) => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = communityHealthProposed.filter((a) => !cond.excludeOnly.includes(a));
            } else {
              list = cond.excludeFrom?.filter((a) => !cond.excludeList.includes(a)) || [];
            }
          }
        } else if (primaryUse === "Community Facilities (Educational Buildings)") {
          if (cond.match) {
            let list = [];
            if (cond.includeOnly) {
              list = communityEducationProposed.filter((a) => cond.includeOnly.includes(a));
            } else if (cond.excludeList) {
              list = communityEducationProposed.filter((a) => !cond.excludeList.includes(a));
            } else {
              list = cond.excludeFrom || [];
            }
            return simpleReturn(list);
          }
        } else if (primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = publicAmenitiesProposed.filter((a) => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = publicAmenitiesProposed.filter((a) => !cond.excludeOnly.includes(a));
            } else {
              list = cond.excludeFrom?.filter((a) => !cond.excludeList.includes(a)) || [];
            }
          }
        }

        // Return filtered list based on primaryUse
        return simpleReturn(list);
      }
    }

    // Default return (all residential activities)
    return simpleReturn(resProposed);
  };

  const handleClick = () => {
    setIsModalOpen(true);
    // addPlotNo({ plotNo: getValues("plotNo") });
  };

  // Convert to number safely
  const plotArea = parseFloat(watchPlotArea) || 0;
  const isMoreThan4Hectares = plotArea >= 40000;
  console.log("getFilteredActivityoptions", getFilteredActivityOptions);

  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div className="formContainer">
          {/* {watchPlanOn && (
            <div className="formHeaderContainer">
              <h4 className="formHeading" style={{ background: "#f2f2f2", textAlign: "end", fontSize: "20px", color: "green" }}>
                {t(`${riskType === "Others" ? "High Risk and High Nivesh" : riskType}`)}
              </h4>
            </div>
          )} */}
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Application Form")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="FASTPAS ID"
                  placeholder="Enter FASTPAS ID."
                  name="fastPASId"
                  type="textInput"
                  mandatory
                  disabled={isRescrutiny}
                  defaultValue={formData?.fastPASId}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  showSearchIcon={true}
                  onSearchClick={() => handleSearchClick(getValues("fastPASId"))}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={"Scheme Type"}
                  control={control}
                  placeholder={t("Scheme Type")}
                  name="descriptionOfLand.schemeType"
                  mandatory
                  defaultValue={formData?.descriptionOfLand?.schemeType || fastPASData?.descriptionOfLand?.schemeType}
                  type="textInput"
                  disabled={fastPASData?.descriptionOfLand?.schemeType || isRescrutiny}
                // data={SortingAlphabatically(schemeTypeList)}
                />
              </Col>
            </Row>

            <Row>
              {watchSchemeType !== "Non Scheme" && (
                <Col>
                  <InputWrapper
                    label="Type Of Scheme"
                    // data={SortingAlphabatically(TypeOfSchemeOptions)}
                    control={control}
                    placeholder="Type Of Scheme"
                    name="planOn"
                    mandatory
                    defaultValue={fastPASData?.descriptionOfLand?.planOn || formData?.planOn}
                    type="selectInput"
                    disabled={fastPASData?.descriptionOfLand?.planOn || isRescrutiny}
                  // data={SortingAlphabatically(schemeTypeList)}
                  />
                </Col>
              )}
              {watchSchemeType !== "Non Scheme" ? (
                <Col>
                  <InputWrapper
                    label="Scheme Name"
                    control={control}
                    placeholder="Scheme Name"
                    defaultValue={fastPASData?.descriptionOfLand?.schemeName || formData?.descriptionOfLand?.schemeName}
                    name="descriptionOfLand.schemeName"
                    type="textInput"
                    disabled={fastPASData?.descriptionOfLand?.schemeName || isRescrutiny}
                    // data={SortingAlphabatically(schemeNameList)}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            {watchSchemeType !== "Non Scheme" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Layout Sanction No.")}
                    control={control}
                    placeholder={t("Enter layout sanction number")}
                    name="layoutsanctionNumber"
                    defaultValue={formData?.layoutsanctionNumber}
                    type="textInput"
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("Layout Sanction Date")}
                    control={control}
                    placeholder={t("Enter Layout Sanction date")}
                    name="layoutsanctionDate"
                    defaultValue={formData?.layoutsanctionDate}
                    type="datePicker"
                    disableFuture={true}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landUseList)}
                  label={t("Land Use as per Layout Plan")}
                  placeholder={t("Select Type of Land")}
                  name="zoneType"
                  defaultValue={formData?.zoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchlandUseType || isRescrutiny}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landSubUseList)}
                  label={t("Land Sub-use as per layout Plan")}
                  placeholder={t("Select Type of Land Subuse")}
                  name="subZoneType"
                  defaultValue={formData?.descriptionOfLand?.subLandUseAsPerLayout || formData?.subZoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={watchSubZoneType || isRescrutiny}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(formattedCategoryArray)}
                  label={t("Primary Use of Proposed Activity")}
                  placeholder={t("Select Primary Use of Proposed Activity")}
                  name="primaryUse"
                  defaultValue={formData?.primaryUse}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchPrimaryUse || isRescrutiny}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(getFilteredActivityOptions() || [])}
                  label={t("Activity proposed")}
                  placeholder={t("Select Type of Activity proposed")}
                  name="activityProposed"
                  defaultValue={formData?.activityProposed}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchAtivityProposed || isRescrutiny}
                />
              </Col>
            </Row>

            <Row>
              {(watchAtivityProposed === "Hotel (<20 rooms)" || watchAtivityProposed === "Hotel (>20 rooms)") && (
                <Col>
                  <InputWrapper
                    control={control}
                    label={t("Number Of Rooms")}
                    placeholder={t("Number Of Rooms")}
                    name="numberOfHotels"
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      validate: (value) => {
                        const num = Number(value);

                        if (watchAtivityProposed === "Hotel (<20 rooms)" && num > 20) {
                          return "For hotels with <20 rooms, number must not exceed 20";
                        }

                        if (watchAtivityProposed === "Hotel (>20 rooms)" && num <= 20) {
                          return "For hotels with >20 rooms, number must be greater than 20";
                        }

                        return true;
                      },
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "Please enter a valid number",
                      },
                    }}
                  />
                </Col>
              )}
              <Col></Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  label={t("Development Area")}
                  control={control}
                  placeholder={t("Development Area Type")}
                  // data={SortingAlphabatically(ConstructionTypeOptions
                  name="descriptionOfLand.developmentArea"
                  mandatory
                  defaultValue={fastPASData?.descriptionOfLand?.developmentArea || formData?.descriptionOfLand?.developmentArea}
                  disabled={true}
                  type="textInput"
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Nature of Construction /Case Type")}
                  placeholder={t("Select Nature Of Construction")}
                  name="natureOfConstruction"
                  defaultValue={formData?.natureOfConstruction}
                  data={SortingAlphabatically(isProd ? natureOfConstructionOption2 : natureOfConstructionOption)}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isSelfCert || isRescrutiny}
                />
              </Col>
            </Row>
            {(watchnatureOfConstruction === "Revalidation/Time Extension" ||
              watchnatureOfConstruction === "Redevelopment/Reconstruction" ||
              watchnatureOfConstruction === "Revision" ||
              watchnatureOfConstruction === "Addition Extension" ||
              (watchnatureOfConstruction === "Compounding" && watchCompunding === "yes")) && (
                <React.Fragment>
                  {" "}
                  <Row>
                    <Col>
                      <InputWrapper
                        label={t("Previous Sanction date")}
                        control={control}
                        placeholder={t("Enter Previous Sanction date")}
                        name="mapSubDetails.sanctionValidityStartDate"
                        defaultValue={formData?.mapSubDetails?.sanctionValidityStartDate}
                        type="datePicker"
                        disabled={fastPASData?.layoutsanctionDate || formData?.mapSubDetails?.sanctionValidityStartDate || isRescrutiny}
                        mandatory={watchnatureOfConstruction === "Revalidation/Time Extension" || watchnatureOfConstruction === "Revision"}
                        validation={
                          watchnatureOfConstruction === "Revalidation/Time Extension" || watchnatureOfConstruction === "Revision"
                            ? {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }
                            : {}
                        }
                      />
                    </Col>
                    <Col>
                      <InputWrapper
                        label={t("Previous Sanction Validity date")}
                        control={control}
                        placeholder={t("Enter Previous Sanction Validity date")}
                        name="mapSubDetails.sanctionValidityDate"
                        defaultValue={formData?.mapSubDetails?.sanctionValidityDate}
                        type="datePicker"
                        mandatory={watchnatureOfConstruction === "Revalidation/Time Extension" || watchnatureOfConstruction === "Revision"}
                        disabled={fastPASData?.validityDate || formData?.mapSubDetails?.sanctionValidityDate || isRescrutiny}
                        validation={
                          watchnatureOfConstruction === "Revalidation/Time Extension" || watchnatureOfConstruction === "Revision"
                            ? {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }
                            : {}
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <InputWrapper
                        label={t("Previous Approved Map Number")}
                        control={control}
                        placeholder={t("Enter Previous File No")}
                        name="mapSubDetails.prevFileNo"
                        mandatory={watchnatureOfConstruction === "Revalidation/Time Extension" || watchnatureOfConstruction === "Revision"}
                        disabled={fastPASData?.additionalDetails?.oldCaseApplicationNo || formData?.mapSubDetails?.prevFileNo || isRescrutiny}
                        defaultValue={formData?.mapSubDetails?.prevFileNo}
                        type="textInput"
                        validation={
                          watchnatureOfConstruction === "Revalidation/Time Extension" || watchnatureOfConstruction === "Revision"
                            ? {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }
                            : {}
                        }
                      />
                    </Col>
                    <Col></Col>
                  </Row>
                </React.Fragment>
              )}
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="Plot area (as per document) (sq. m)"
                  placeholder="Enter Plot area (as per document) (sq. m)"
                  defaultValue={formData?.descriptionOfLand?.landArea}
                  name="plotArea"
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  mandatory
                  validation={{
                    required: {
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  maxLength={6}
                  disabled={isRescrutiny}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label="Plot area (as per site) (sq. m)"
                  placeholder="Enter Plot area (as per site) (sq. m)"
                  defaultValue={formData?.plotAreaDoc}
                  name="plotAreaDoc"
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  mandatory
                  message="The value must not exceed plot area as per document"
                  validation={{
                    required: {
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  disabled={isRescrutiny}
                  maxLength={6}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label="Latitude"
                  control={control}
                  placeholder="Enter Latitude"
                  name="descriptionOfLand.latitude"
                  type="specialChar"
                  allowedChars="."
                  defaultValue={fastPASData?.descriptionOfLand?.latitude || formData?.descriptionOfLand?.latitude}
                  onlyNumeric={true}
                  disabled={fastPASData?.descriptionOfLand?.latitude || formData?.latitude || isRescrutiny}
                  mandatory
                  isRequired={true}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Coordinates"),
                      message: "Value cannot be zero. Please provide valid coordinate.",
                    },
                  }}
                  minLength={8}
                  maxLength={10}
                />
              </Col>
              <Col>
                <InputWrapper
                  label="Longitude"
                  control={control}
                  placeholder="Enter Longitude"
                  name="descriptionOfLand.longitude"
                  type="specialChar"
                  disabled={fastPASData?.descriptionOfLand?.longitude || formData?.longitude || isRescrutiny}
                  defaultValue={fastPASData?.descriptionOfLand?.longitude || formData?.descriptionOfLand?.longitude}
                  allowedChars="."
                  onlyNumeric={true}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Coordinates"),
                      message: "Value cannot be zero. Please provide valid coordinate.",
                    },
                  }}
                  isRequired={true}
                  maxLength={10}
                  minLength={8}
                />
              </Col>
            </Row>
            {watchSpecialProject === "Type design" && (
              <React.Fragment>
                {isModalOpen && (
                  <PlotDetailTable
                    addPlotNo={addPlotNo}
                    control={control}
                    getValues={getValues}
                    isModalOpen={isModalOpen}
                    isRescrutiny={isRescrutiny}
                    modalFields={modalFields}
                    removePlotNo={removePlotNo}
                    setIsModalOpen={setIsModalOpen}
                    setShowToast={setShowToast}
                  />
                )}
              </React.Fragment>
            )}
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  // data={updistricts}
                  label={t("District")}
                  placeholder={t("District")}
                  defaultValue={formData?.district || ""}
                  name="district"
                  type="textInput"
                  disabled={isRescrutiny}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Nearby Land Mark")}
                  control={control}
                  placeholder={t("Enter Land Mark")}
                  name="landMark"
                  mandatory={!schemeType}
                  maxLength={15}
                  defaultValue={formData?.landMark}
                  type="textInput"
                  disabled={watchLandMark || isRescrutiny}
                  validation={{
                    required: {
                      value: !schemeType,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            {watchSchemeType === "Non Scheme" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Tehsil")}
                    control={control}
                    placeholder={t("Enter Tehsil")}
                    name="tehsil"
                    defaultValue={formData?.tehsil}
                    type="textInput"
                    disabled={!!watchTehsil || isRescrutiny}
                    validation={{
                      required: {
                        value: !schemeType,
                        message: "This field is required",
                      },
                    }}
                    mandatory={!schemeType}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label="Revenue Village/Colony Name"
                    control={control}
                    placeholder="Enter Revenue Village"
                    defaultValue={formData?.revenueVillage}
                    name={`revenueVillage`}
                    type="textInput"
                    mandatory={!schemeType}
                    disabled={isRescrutiny}
                    validation={{
                      required: {
                        value: !schemeType,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              </Row>
            )}
            {watchSchemeType === "Non Scheme" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Land Address")}
                    control={control}
                    placeholder={t("Enter Address")}
                    name="landAddress"
                    defaultValue={formData?.landAddress}
                    type="textInput"
                    disabled
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    mandatory={true}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label="Development Plan"
                    control={control}
                    placeholder="Enter Development Plan"
                    defaultValue={formData?.developmentPlan}
                    name={`developmentPlan`}
                    type="selectInput"
                    data={developmentPlans}
                    disabled={isRescrutiny}
                  // validation={{
                  //   required: {
                  //     value: !schemeType,
                  //     message: "This field is required",
                  //   },
                  // }}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="Road width (existing) (m)"
                  placeholder="Enter Road width (existing) (m)"
                  // defaultValue={formData?.descriptionOfLand?.roadWidths[0]}
                  name="descriptionOfLand.roadWidths[0].value"
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  defaultValue={formData?.descriptionOfLand?.roadWidths?.[0]?.value}
                  mandatory
                  disabled={isRescrutiny}
                  containerStyles={{ width: "100%" }}
                  isRequired={true}
                  maxLength={5}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={schemeType ? "Road width (As per layout Plan)" : "Road width (As per master Plan)"}
                  placeholder="Enter Road width"
                  // defaultValue={field.value}
                  name={`descriptionOfLand.approachRoadWidths[0].value`}
                  defaultValue={formData?.descriptionOfLand?.approachRoadWidths?.[0]?.value}
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  mandatory
                  disabled={isRescrutiny}
                  containerStyles={{ width: "100%" }}
                  isRequired={true}
                  maxLength={5}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={restrictedLayoutActivities ? proposalOptionsPlotted : proposalOptions}
                  label={`${t("Select Proposal")}`}
                  placeholder={"Select Proposal"}
                  name="proposal"
                  disabled={isRescrutiny}
                  defaultValue={formData?.proposal}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                {(watchAtivityProposed === "Petrol Pump/ Filling Station (CNG/PNG/EV,For 2/3 wheelers vehicles)" ||
                  watchAtivityProposed === "Petrol Pump/ Filling Station (CNG/PNG/EV,For All vehicles)" ||
                  watchAtivityProposed === "Petrol Pump/ Filling Station cum Service Station (CNG/PNG/EV)") && (
                    <InputWrapper
                      control={control}
                      label={t("Plot Size Prescribed By Oil Company")}
                      placeholder={t("Plot Size Prescribed By Oil Company")}
                      name="plotSizePrescribed"
                      type="radioButton"
                      allowedChars="."
                      onlyNumeric={true}
                      mandatory
                      data={yesOrNo}
                      //  defaultValue={formData?.totalBuiltUpArea}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  )}
              </Col>
            </Row>
            {isDA && (
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={t("Select Zone")}
                    placeholder={t("Select Zone")}
                    name="zone"
                    defaultValue={formData?.zone}
                    type="selectInput"
                    // mandatory
                    data={zoneList}
                  // validation={{
                  //   required: {
                  //     value: true,
                  //     message: "This field is required",
                  //   },
                  // }}
                  />
                </Col>
                <Col></Col>
              </Row>
            )}
            <Row>
              {watchPrimaryUse === "Community Facilities (Educational Buildings)" && (
                <Col>
                  <InputWrapper
                    control={control}
                    label={t("No Of Students")}
                    placeholder={t("Enter No Of Students")}
                    name="mapSubDetails.noOfStudents"
                    defaultValue={formData?.mapSubDetails?.noOfStudents}
                    type="number"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "Please enter a valid number",
                      },
                    }}
                  />
                </Col>
              )}
              {watchPrimaryUse === "Community Facilities (Public Amenities/Utilities Buildings" ||
                ("Parks, Play-ground / Open-spaces, Recreational" &&
                  (watchAtivityProposed === "Auditorium" ||
                    watchAtivityProposed === "Convention Centre" ||
                    watchAtivityProposed === "Stadium" ||
                    watchAtivityProposed === "Multiplex") && (
                    <Col>
                      <InputWrapper
                        control={control}
                        label={t("Number of Seats")}
                        placeholder={t("No Of Seats")}
                        name="mapSubDetails.noOfSeats"
                        defaultValue={formData?.mapSubDetails?.noOfSeats}
                        type="number"
                        mandatory
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                          pattern: {
                            value: /^[0-9]+$/,
                            message: "Please enter a valid number",
                          },
                        }}
                      />
                    </Col>
                  ))}
              <Col></Col>
            </Row>
            <Row>
              {watchPrimaryUse === "Community Facilities (Healthcare Buildings)" && watchAtivityProposed === "Hospitals (> 50 beds)" && (
                <Col>
                  <InputWrapper
                    control={control}
                    label={t("Number of Beds")}
                    placeholder={t("Number of Beds")}
                    name="mapSubDetails.noOfBeds"
                    defaultValue={formData?.mapSubDetails?.noOfBeds}
                    type="number"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}
              {watchPlotSizePrescribed === "yes" ? (
                <Col>
                  <FileUploader
                    isMandatory
                    // hasLabel={false}
                    control={control}
                    name="plotSizePrescribedDoc"
                    label="Plot Size Prescribed Document"
                    validationMsg="(pdf file only and Max file Size 30 MB)"
                    className="custom-file-uploader"
                    required
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            <Row>
              {!restrictedLayoutActivities && (
                <Col>
                  <InputWrapper
                    control={control}
                    data={dropDownData?.yesOrNo}
                    label={t("Is this Special Project")}
                    name="isRevised"
                    defaultValue={formData?.isRevised}
                    disabled={isRescrutiny}
                    type="radioButton"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}
              {watchProposal !== "Layout Development" && watchisRevised == "yes" ? (
                <Col>
                  <InputWrapper
                    control={control}
                    label={`${t("Special project")}`}
                    name="specialProject"
                    placeholder={"Select Special Project"}
                    defaultValue={formData?.specialProject}
                    type="selectInput"
                    data={
                      watchAtivityProposed === "Row Housing - Single units" ||
                        watchAtivityProposed === "Detached - Single Units" ||
                        watchAtivityProposed === "Semi-Detached - Single Units" ||
                        watchAtivityProposed === "Single Housing - EWS" ||
                        watchAtivityProposed === "Single Housing - LIG"
                        ? specialProjectList?.filter((item) =>
                          watchSubZoneType === "Mixed Use 1 & 2" ? item.value !== "Mixed Use Along 18/24M Wide Road" : true
                        )
                        : specialProjectList?.filter(
                          (item) =>
                            item.value !== "Type design" &&
                            !(watchSubZoneType === "Mixed Use 1 & 2" && item.value === "Mixed Use Along 18/24M Wide Road")
                        )
                    }
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            <Row>
              {/* {watchSpecialProject === "Transit Oriented Development (TOD)" && watchisRevised === "yes" ? (
                <Col>
                  <InputWrapper
                    control={control}
                    label={`${t("Converted Land use under TOD")}`}
                    name="tod"
                    type="radioButton"
                    mandatory
                    data={yesOrNo}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              ) : (
                <Col></Col>
              )} */}
              {!restrictedLayoutActivities ? (
                <Col>
                  <InputWrapper
                    control={control}
                    label={`${t("Does your proposal require other than Base FAR")}`}
                    name="mapSubDetails.proposalTypeFAR"
                    defaultValue={formData?.mapSubDetails?.proposalTypeFAR}
                    type="radioButton"
                    height={40}
                    mandatory
                    data={yesOrNo}
                    disabled={isRescrutiny}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            {/* Greyed Code */}
            {watchProposalTypeFAR === "yes" &&
              watchPrimaryUse === "Residential" &&
              (watchAtivityProposed === "Row Housing - Single units" ||
                watchAtivityProposed === "Row Housing - Multi units" ||
                watchAtivityProposed === "Detached - Multi Units" ||
                watchAtivityProposed === "Detached - Single Units" ||
                watchAtivityProposed === "Semi-detached - Multi Units" ||
                watchAtivityProposed === "Semi-Detached - Single Units" ||
                watchAtivityProposed === "Group Housing" ||
                watchAtivityProposed === "Group Housing - Affordable" ||
                watchAtivityProposed === "Group Housing - EWS" ||
                watchAtivityProposed === "Single Housing - EWS" ||
                watchAtivityProposed === "Single Housing - LIG" ||
                watchAtivityProposed === "Plotted Development" ||
                watchAtivityProposed === "Plotted Development - Affordable") && (
                // (watchSchemeType === "Scheme" || watchSchemeType === "Non-Scheme") &&
                <Fragment>
                  <Row>
                    <Col>
                      {!(
                        (watchAtivityProposed === "Single Housing - EWS" && watchSchemeType === "Non Scheme") ||
                        (watchAtivityProposed === "Single Housing - LIG" && watchSchemeType === "Non Scheme") ||
                        watchAtivityProposed === "Plotted Development" ||
                        watchAtivityProposed === "Plotted Development - Affordable" ||
                        watchProposal === "Layout Development"
                      ) && (
                          <InputWrapper
                            control={control}
                            label={`${t("Purchasable FAR")}`}
                            name="purchasableFar"
                            defaultValue={formData?.purchasableFar}
                            type="radioButton"
                            mandatory
                            data={yesOrNo}
                            validation={{
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }}
                          />
                        )}
                    </Col>
                    <Col>
                      {(watchAtivityProposed === "Group Housing" ||
                        watchAtivityProposed === "Group Housing - Affordable" ||
                        watchAtivityProposed === "Group Housing - EWS" ||
                        watchAtivityProposed === "Group Housing - LIG" ||
                        watchProposal === "Layout Development") &&
                        watchPurchasableFar === "yes" && (
                          <InputWrapper
                            control={control}
                            label={`${t("Purchasable Premium FAR")}`}
                            name="purchasablePremiumFAR"
                            defaultValue={formData?.purchasablePremiumFAR}
                            type="radioButton"
                            mandatory
                            data={yesOrNo}
                            validation={{
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }}
                          />
                        )}
                    </Col>
                  </Row>
                  <Row>
                    {watchPurchasableFar === "yes" && (
                      <React.Fragment>
                        <Col>
                          <InputWrapper
                            control={control}
                            label={"Basic FAR"}
                            placeholder="Enter Basic FAR"
                            type="specialChar"
                            allowedChars="."
                            onlyNumeric={true}
                            name="basicFAR"
                            defaultValue={
                              formData?.basicFAR === 0 || purchasableData?.basicFAR == 0 ? "0" : formData?.basicFAR || purchasableData?.basicFAR
                            }
                            mandatory
                            disabled={
                              formData?.basicFAR === 0 || purchasableData?.basicFAR == 0 ? "0" : formData?.basicFAR || purchasableData?.basicFAR
                            }
                            containerStyles={{ width: "100%" }}
                            isRequired={true}
                            validation={{
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }}
                          />
                        </Col>
                        <Col>
                          <InputWrapper
                            control={control}
                            label={"Purchasable FAR"}
                            placeholder="Enter Purchasable FAR"
                            defaultValue={
                              formData?.purchasableFAR === 0 || purchasableData?.purchasableFAR == 0
                                ? "0"
                                : formData?.purchasableFAR || purchasableData?.purchasableFAR
                            }
                            mandatory
                            name="purchasableFAR"
                            type="specialChar"
                            allowedChars="."
                            onlyNumeric={true}
                            disabled={
                              formData?.purchasableFAR === 0 || purchasableData?.purchasableFAR == 0
                                ? "0"
                                : formData?.purchasableFAR || purchasableData?.purchasableFAR
                            }
                            containerStyles={{ width: "100%" }}
                            isRequired={true}
                            validation={{
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }}
                          />
                        </Col>
                      </React.Fragment>
                    )}
                  </Row>
                  <Row>
                    {watchPurchasableFar === "yes" && (
                      <React.Fragment>
                        <Col>
                          <InputWrapper
                            control={control}
                            label={"Premium FAR"}
                            placeholder="Enter Premium FAR"
                            defaultValue={
                              formData?.premiumFAR === 0 || purchasableData?.premiumFAR == 0
                                ? "0"
                                : formData?.premiumFAR || purchasableData?.premiumFAR
                            }
                            mandatory
                            type="specialChar"
                            allowedChars="."
                            onlyNumeric={true}
                            name="premiumFAR"
                            disabled={
                              formData?.premiumFAR === 0 || purchasableData?.premiumFAR == 0
                                ? "0"
                                : formData?.premiumFAR || purchasableData?.premiumFAR
                            }
                            containerStyles={{ width: "100%" }}
                            isRequired={true}
                            validation={{
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }}
                          />
                        </Col>
                        <Col></Col>
                      </React.Fragment>
                    )}
                  </Row>
                  <Row>
                    {/* <Col>
                      {(watchAtivityProposed === "Group Housing" ||
                        watchAtivityProposed === "Group Housing - Affordable" ||
                        watchAtivityProposed === "Group Housing - EWS" ||
                        watchProposal === "Layout Development") && (
                        <InputWrapper
                          control={control}
                          label={`${t("Green Building FAR")}`}
                          name="greenBuildingFAR"
                          defaultValue={formData?.greenBuildingFAR}
                          type="radioButton"
                          data={yesOrNo}
                          validation={{
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          }}
                        />
                      )}
                    </Col> */}
                    {/* <Col>
                      {["Detached - Multi Units", "Semi-detached - Multi Units", "Group Housing", "Row Housing - Multi units"].includes(
                        watchAtivityProposed
                      ) && (
                        <InputWrapper
                          control={control}
                          label="Payment of Shelter fee?"
                          name="shelterFee"
                          type="radioButton"
                          mandatory
                          defaultValue={isMoreThan4Hectares ? "no" : formData?.shelterFee || ""}
                          disabled={isMoreThan4Hectares}
                          data={yesOrNo}
                          validation={{
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          }}
                        />
                      )}
                    </Col> */}
                    <Col></Col>
                  </Row>
                  {/* <Row> */}
                  {/* <Col>
                      {!(
                        watchAtivityProposed === "Row Housing - Single units" ||
                        watchAtivityProposed === "Single Housing - EWS" ||
                        watchAtivityProposed === "Single Housing - LIG" ||
                        watchAtivityProposed === "Group Housing - Affordable" ||
                        watchAtivityProposed === "Row Housing - Single units" ||
                        watchAtivityProposed === "Group Housing - EWS & LIG"
                      ) &&
                        watchShelterFee === "no" && (
                          <InputWrapper
                            control={control}
                            label={`${t("Performance Gaurantee against EWS/LIG")}`}
                            placeholder={"Select Guarantee"}
                            name="performanceGuarantee"
                            defaultValue={formData?.performanceGuarantee}
                            type="selectInput"
                            height={40}
                            data={guaranteeList}
                            mandatory
                            validation={{
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }}
                          />
                        )}
                    </Col> */}
                  {/* <Col>
                      {(watchAtivityProposed === "Row Housing - Single units" ||
                        watchAtivityProposed === "Row Housing - Multi units" ||
                        watchAtivityProposed === "Group Housing - Affordable" ||
                        watchAtivityProposed === "Group Housing" ||
                        (watchAtivityProposed === "Group Housing - EWS" && watchSchemeType == "Non Scheme")) &&
                        watchSchemeType === "Non Scheme" && (
                          <InputWrapper
                            control={control}
                            label={`${t("Compensatory FAR")}`}
                            name="compensatoryFAR"
                            defaultValue={formData?.compensatoryFAR}
                            type="radioButton"
                            mandatory
                            data={yesOrNo}
                            validation={{
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }}
                          />
                        )}
                    </Col> */}
                  {/* <Col></Col>
                  </Row> */}
                </Fragment>
              )}
            {watchProposalTypeFAR === "yes" && (
              <Row>
                <Row>
                  <Col>
                    {!(
                      watchAtivityProposed === "Row Housing - Single units" ||
                      watchAtivityProposed === "Semi-Detached - Single Units" ||
                      watchAtivityProposed === "Detached - Single Units" ||
                      watchAtivityProposed === "Plotted Development" ||
                      watchAtivityProposed === "Plotted Development - Affordable" ||
                      watchAtivityProposed === "Single Housing - EWS" ||
                      watchAtivityProposed === "Single Housing - LIG"
                    ) && (
                        <InputWrapper
                          control={control}
                          label={`${t("Green Building FAR")}`}
                          name="greenBuildingFAR"
                          defaultValue={formData?.greenBuildingFAR}
                          type="radioButton"
                          mandatory
                          data={yesOrNo}
                          validation={{
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          }}
                        />
                      )}
                  </Col>
                  <Col></Col>
                </Row>
                {watchProposal !== "Layout Development" && watchGreenBuildingFAR === "yes" && (
                  <Row>
                    <Col>
                      <InputWrapper
                        control={control}
                        label={`${t("Green Building Rated requires additional FAR")}`}
                        placeholder={"Select Percentage"}
                        name="greenAdditionalFAR"
                        defaultValue={formData?.greenAdditionalFAR}
                        type="selectInput"
                        data={additionalFar}
                      />
                    </Col>
                    <Col>
                      <FileUploader
                        isMandatory
                        // hasLabel={false}
                        control={control}
                        name="greenBuildingDoc"
                        label="Green Building Document"
                        validationMsg="(pdf file only and Max file Size 30 MB)"
                        className="custom-file-uploader"
                        required
                      />
                    </Col>
                  </Row>
                )}
              </Row>
            )}
            {watchProposalTypeFAR === "yes" && (
              <Row>
                <Row>
                  <Col>
                    {!(watchAtivityProposed === "Plotted Development" || watchAtivityProposed === "Plotted Development - Affordable") && (
                      <InputWrapper
                        control={control}
                        label={`${t("Compensatory FAR")}`}
                        name="compensatoryFAR"
                        defaultValue={formData?.compensatoryFAR}
                        type="radioButton"
                        mandatory
                        data={yesOrNo}
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        }}
                      />
                    )}
                  </Col>
                  <Col></Col>
                </Row>
                {watchCompensatoryFAR === "yes" && (
                  <Row>
                    <Col>
                      <InputWrapper
                        control={control}
                        label={`${t("Area of Transferred Land")}`}
                        name="transferredLandArea"
                        placeholder={"Enter Area"}
                        defaultValue={formData?.transferredLandArea}
                        type="textInput"
                        mandatory
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        }}
                      />
                    </Col>
                    <Col>
                      <FileUploader
                        isMandatory
                        // hasLabel={false}
                        control={control}
                        name="compensatoryFarDoc"
                        label="Compensatory FAR Document"
                        validationMsg="(pdf file only and Max file Size 30 MB)"
                        required
                      />
                    </Col>
                  </Row>
                )}
              </Row>
            )}

            {/* {watchProposalTypeFAR === "yes" && (
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={`${t("Payment of Shelter fee?")}`}
                    name="shelterFee"
                    defaultValue={formData?.shelterFee}
                    type="radioButton"
                    mandatory
                    data={yesOrNo}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    control={control}
                    label={`${t("Permornamce Gaurantee against EWS/LIG")}`}
                    placeholder={"Select Guarantee"}
                    name="performanceGuarantee"
                    defaultValue={formData?.performanceGuarantee}
                    type="selectInput"
                    data={guaranteeList}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              </Row>
            )} */}

            <Row>
              {!restrictedLayoutActivities && (
                <Col>
                  {" "}
                  <InputWrapper
                    control={control}
                    label={`${t("Special Project type")}`}
                    name="isSpecialProject"
                    defaultValue={formData?.isSpecialProject}
                    type="radioButton"
                    data={yesOrNo}
                    disabled={isRescrutiny}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}
              {watchProposal !== "Layout Development" && watchisSpecialProject === "yes" ? (
                <Col>
                  <InputWrapper
                    label={t("Special Condition of Project")}
                    control={control}
                    placeholder={t("Select Condition of Project")}
                    data={SortingAlphabatically(specialProjectOptions)}
                    name="projectType"
                    mandatory
                    defaultValue={formData?.projectType}
                    type="selectInput"
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>

            {[
              "Detached - Multi Units",
              "Semi-detached - Multi Units",
              "Group Housing",
              "Row Housing - Multi units",
              "Layout Plan (Residential)",
            ].includes(watchAtivityProposed) && (
                <React.Fragment>
                  <Row>
                    <Col>
                      <InputWrapper
                        control={control}
                        label="Payment of Shelter fee?"
                        name="shelterFee"
                        type="radioButton"
                        mandatory
                        defaultValue={isMoreThan4Hectares ? "no" : formData?.shelterFee || ""}
                        disabled={isMoreThan4Hectares}
                        data={yesOrNo}
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        }}
                      />
                    </Col>
                    <Col />
                  </Row>

                  {watchShelterFee === "no" && (
                    <Row>
                      <Col>
                        <InputWrapper
                          control={control}
                          label={t("Performance Gaurantee against EWS/LIG")}
                          placeholder="Select Guarantee"
                          name="performanceGuarantee"
                          defaultValue={formData?.performanceGuarantee}
                          type="selectInput"
                          height={40}
                          data={guaranteeList}
                          mandatory
                          validation={{
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          }}
                        />
                      </Col>
                      <Col />
                    </Row>
                  )}
                </React.Fragment>
              )}

            {watchisSpecialProject === "yes" && (
              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    control={control}
                    label={t("Ground Coverage")}
                    placeholder={t("Enter Ground Coverage")}
                    name="groundCoverages"
                    defaultValue={formData?.groundCoverages || formData?.groundCoverage}
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    maxLength={4}
                  />
                </Col>

                <Col>
                  {" "}
                  <InputWrapper
                    control={control}
                    label={t("FAR")}
                    placeholder={t("Enter FAR")}
                    name="fars"
                    defaultValue={formData?.fars || formData?.far}
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    maxLength={4}
                  />
                </Col>
              </Row>
            )}

            {watchisSpecialProject === "yes" && (
              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    control={control}
                    label={t("Building Height")}
                    placeholder={t("Enter Building Height")}
                    name="buildingHeight"
                    defaultValue={formData?.buildingHeight}
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    maxLength={4}
                  />
                </Col>
                {/* <Col>
                  <InputWrapper
                    control={control}
                    label={t("Setbacks")}
                    placeholder={t("Enter setbacks")}
                    name="setbacks"
                    defaultValue={formData?.setbacks}
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col> */}
                <Col></Col>
              </Row>
            )}

            {watchisSpecialProject === "yes" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Front Setback")}
                    control={control}
                    placeholder={t("Enter Front")}
                    name="previousSetbackFront"
                    mandatory
                    maxLength={2}
                    defaultValue={formData?.previousSetbackFront || formData?.setbackFronts}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("Rear Setback")}
                    control={control}
                    placeholder={t("Enter Rear")}
                    name="previousSetbackRear"
                    mandatory
                    maxLength={2}
                    defaultValue={formData?.previousSetbackRear || formData?.setbackRears}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              </Row>
            )}

            {watchisSpecialProject === "yes" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Side Setback-1")}
                    control={control}
                    placeholder={t("Enter Side Setback-1")}
                    name="previousSetbackSide1"
                    mandatory
                    maxLength={2}
                    defaultValue={formData?.previousSetbackSide1 || formData?.setbackSide1}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("Side Setback-2")}
                    control={control}
                    placeholder={t("Enter Side Setback-2")}
                    name="previousSetbackSide2"
                    mandatory
                    maxLength={2}
                    defaultValue={formData?.previousSetbackSide2 || formData?.setbackSide2}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              </Row>
            )}
            <Row>
              {(includeIsBuildingFullySprinkledActivities.includes(watchAtivityProposed) ||
                sprinklerRequiredPrimaryUses.includes(watchPrimaryUse)) && (
                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={`${t("Is building fully sprinklered for Fire Fighting?")}`}
                      name="mapSubDetails.fireFighting"
                      defaultValue={formData?.mapSubDetails?.fireFighting}
                      type="radioButton"
                      data={yesOrNo}
                      height={40}
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                )}
              <Col></Col>
            </Row>

            <Row>
              <Col>
                {" "}
                {watchAtivityProposed === "Plotted Development" && (
                  <InputWrapper
                    control={control}
                    label={`${t("Does your proposal comprising Multi-units / Group Housing")}`}
                    name="groupHousingOrMultiUnits"
                    // defaultValue={formData?.fireFighting}
                    type="radioButton"
                    data={yesOrNo}
                    height={40}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                )}
              </Col>
              <Col></Col>
            </Row>

            {watchnatureOfConstruction === "Compounding" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Is building plan previously approved?")}
                    control={control}
                    name="serviceType"
                    mandatory
                    data={yesOrNo}
                    defaultValue={formData?.serviceType}
                    type="radioButton"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                {watchCompunding !== "no" && <Col></Col>}
                {watchCompunding === "no" && (
                  <Col>
                    <InputWrapper
                      control={control}
                      label={t("Nature of compounding")}
                      placeholder={t("Select Nature Of Compounding")}
                      name="isAncestralProperty"
                      defaultValue={formData?.isAncestralProperty}
                      data={SortingAlphabatically(natureOfCompounding)}
                      type="selectInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    // disabled={isSelfCert}
                    />
                  </Col>
                )}
              </Row>
            )}
            {watchCompunding === "no" && watchisAncestralProperty === "In response to notice" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Enter Notice Number")}
                    control={control}
                    placeholder={t("Notice Number  (Mandatory Field)")}
                    name="vaadId"
                    mandatory
                    maxLength={24}
                    defaultValue={formData?.vaadId}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col></Col>
              </Row>
            )}
            <Row>
              {watchSpecialProject === "Type design" ? (
                <Col>
                  <div>
                    <span style={{ color: "red", fontSize: "14px", paddingLeft: "10px", fontWeight: "bold" }}>
                      Please Re-enter the Values of Plot No.
                    </span>
                    <span style={{ fontSize: "16px", marginLeft: "10px" }}>Add Plot No's</span>
                    <IconButton onClick={handleClick}>
                      <AddIcon style={{ color: "green" }} />
                    </IconButton>
                  </div>
                </Col>
              ) : (
                <Col>
                  <InputWrapper
                    label={watchSchemeType !== "Non Scheme" ? t("Plot No") : t("Plot No./Khasra No./ Arazi No.")}
                    control={control}
                    placeholder={watchSchemeType !== "Non Scheme" ? t("Enter Plot no") : t("Enter Plot No./Khasra No./ Arazi No.")}
                    name="plotNo"
                    mandatory
                    defaultValue={formData?.plotNo || fastPASData?.descriptionOfLand?.plotNo}
                    type="textInput"
                    disabled={fastPASData?.descriptionOfLand?.plotNo || formData?.plotNo || isRescrutiny}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}

              <Col>
                <InputWrapper
                  label={t("DM Circle Rate (In Rs. Per Square meter)")}
                  control={control}
                  placeholder={t("Enter DM Rate")}
                  name="dmCircleRate"
                  mandatory
                  defaultValue={formData?.dmCircleRate}
                  disabled={isRescrutiny}
                  type="textInput"
                />
              </Col>
            </Row>

            {watchSpecialProject === "Type design" && (
              <Row>
                <Col
                  style={{
                    marginLeft: "10px",
                  }}
                >
                  Total Plot's Entered : <span style={{ fontWeight: "bold" }}>{modalFields?.length}</span>
                </Col>
              </Row>
            )}

            {watchGroupHousingOrMultiUnits === "yes" && (
              <fieldset className="fieldset-wrapper">
                <legend style={{ fontWeight: "bold", fontSize: "1rem" }}>Permornamce Gaurantee against EWS/LIG</legend>
                <TableContainer className="table-container">
                  <Table stickyHeader className="application-table" border="1" cellPadding="8">
                    <thead
                      style={{
                        background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
                        // background: "#f0f0f0"
                      }}
                    >
                      <tr>
                        <th style={{ width: "25%" }}>
                          {t("LABEL_PLOT_NO")}
                          <span className="compulsoryField"> *</span>
                        </th>
                        <th style={{ width: "20%" }}>
                          {t("Types Of Plots")}
                          <span className="compulsoryField"> *</span>
                        </th>
                        <th style={{ width: "20%" }}>
                          Proposed Units<span className="compulsoryField"> *</span>
                        </th>
                        <th>{t("ACTIONS")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {modalFields &&
                        modalFields?.map((item, index) => (
                          <tr key={item.id}>
                            <td>
                              <InputWrapper
                                name={`mapSubDetails.plotDetails[${index}].plotNo`}
                                control={control}
                                type="textInput"
                                placeholder="Enter Plot No"
                                hasLabel={false}
                                mandatory
                              />
                            </td>
                            <td>
                              <InputWrapper
                                name={`mapSubDetails.plotDetails[${index}].typeOfPlot`}
                                control={control}
                                type="radioButton"
                                data={groupHousingOrMultiUnits}
                                hasLabel={false}
                                mandatory
                              />
                            </td>
                            <td>
                              <InputWrapper
                                name={`mapSubDetails.plotDetails[${index}].proposedUnits`}
                                control={control}
                                type="number"
                                onlyNumeric
                                maxLength={5}
                                placeholder="Enter Proposed Units"
                                hasLabel={false}
                                mandatory
                              />
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <IconButton onClick={() => removePlotNo(index)}>
                                <RemoveIcon />
                              </IconButton>
                              {index === modalFields?.length - 1 && (
                                <IconButton
                                  onClick={() => {
                                    const currentPlotNo = getValues(`mapSubDetails.plotDetails[${modalFields?.length - 1}].plotNo`);
                                    if (!currentPlotNo || currentPlotNo.trim() === "") {
                                      setShowToast({
                                        key: "true",
                                        error: true,
                                        message: "Please fill Plot No before adding another row.",
                                      });
                                      return;
                                    }
                                    addPlotNo({ plotNo: "" });
                                  }}
                                  color="primary"
                                >
                                  <AddIcon />
                                </IconButton>
                              )}
                            </td>
                            {/* <tr style={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>
                            <td colSpan={2}>Total Proposed Units</td>
                            <td>{totalUnits}</td>
                            <td></td>
                          </tr> */}
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </TableContainer>
              </fieldset>
            )}
            <div className="formContainer">
              <FormControlLabel
                style={{ padding: "10px 15px" }}
                control={
                  <Checkbox
                    name="declaration"
                    control={control}
                    onChange={handleDeclarationChange}
                    rules={{ required: "You must agree to the terms and conditions" }}
                  />
                }
                label={
                  <span>
                    I hereby declare that all the layers and information provided in the drawing file are accurate to the best of my knowledge.
                    <br /> The EDCR Scrutiny Engine will run based on this provided data only. Any other drawing-specific layers or information
                    present in the file shall not be the responsibility of the EDCR Engine.
                  </span>
                }
              />
            </div>
          </Container>
        </div>

        {!isSelfCert &&
          scrutinyFlow === "EDCR" &&
          !["Revalidation/Time Extension", "Addition Extension", "Revision"]?.includes(watchnatureOfConstruction) && (
            <div className="formContainer">
              <div className="formHeaderContainer">
                <h2 className="formHeading">{t("Upload DXF File")}</h2>
              </div>
              <Container fluid className="formInputContainer common-app-form custom-upload new-custom-uploader">
                <Row>
                  <DxfFileUploader
                    control={control}
                    name="file"
                    label="Upload Building Plan Drawing"
                    validationMsg="(dxf only and Max file Size 300 MB)"
                    isMandatory
                    required
                    tab={3}
                    setFile={setFile}
                    maxFiles={1}
                  />
                </Row>
              </Container>
            </div>
          )}
        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="success"
              size="medium"
              label="Save"
              type="submit"
              sx={{ backgroundColor: "#157CB3" }}
              disabled={!declarationChecked || watchPlotSubdivided === "yes" || watchplotLeaseHold === "yes" || watchNeedComp === "yes"}
            />
          </div>
        </div>
      </form>
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </section>
  );
};

export default SubStep1;
